<template>
  <div class="d-flex justify-center filter-hover" data-testid="variance-analysis-filter">
    <div class="gemini-loader-container" :class="{ 'loading': showLoader }"> 
      <div class="border-on d-flex shadow-on radius-small cycle-filter-bg d-flex align-center gap-2">
        <div class="d-flex flex-wrap align-center gap-2 filter-container" data-testid="variance-analysis-filter__container">

           <FilterTypes
            type="materiality"
            :show="showmateriality"
            :label="$nova.labelsName('cycle_page','materiality_label','Materiality Type')"
            :items="materialitylist"
            :selected="selectedmateriality"
            :loading="showLoader"
            @change="changeMateriality"
          />

          <div v-if="showmateriality"><div class="filter-divider"></div></div>
           <FilterTypes
            type="cycletype"
            :show="showcycletype"
            :label="$nova.labelsName('cycle_page','cycletype_label','Cycle Type')"
            :items="cycletypelist"
            :selected="selectedcycletype"
            :loading="showLoader"
            @change="changeCycletype"
          />
          <div v-if="showcycletype"><div class="filter-divider"></div></div>
           <FilterTypes
            type="role"
            :show="showrole"
            :label="$nova.labelsName('cycle_page','roles_label','Roles')"
            :items="rolelist"
            :selected="selectedrole"
            :loading="showLoader"
            @change="changeRole"
            :multi-select="showmultirole"
          />
           <div v-if="showrole"><div class="filter-divider"></div></div>
          <FilterTypes
            type="period"
            :show="showperiod"
            :label="$nova.labelsName('cycle_page','month_label','Period')"
            :items="periodlist"
            :selected="selectedperiod"
            :loading="showLoader"
            @change="changePeriod"
          />
          <div v-if="showperiod"><div class="filter-divider"></div></div>
          <FilterTypes
            type="network"
            :show="shownetwork"
            :label="$nova.labelsName('cycle_page','division_label','Network')"
            :items="networklist"
            :selected="selectednetwork"
            :top-items="topnetworklist"
            :search-value="networksearch"
            :loading="showLoader"
            @change="changeNetwork"
            @update:searchValue="onNetworkSearch"
            :multi-select="showmultinetwork"
          />
          <div v-if="shownetwork"><div class="filter-divider"></div></div>
          <FilterTypes
            type="region"
            :show="showregion"
            :label="$nova.labelsName('cycle_page','region_label','Region')"
            :items="regionlist"
            :selected="selectedregion"
            :top-items="topregionlist"
            :search-value="regionsearch"
            :loading="showLoader"
            @change="changeRegion"
            @update:searchValue="onRegionSearch"
            :multi-select="showmultiregion"
          />
          <div v-if="showregion"><div class="filter-divider"></div></div>
          <FilterTypes
            type="country"
            :show="showcountry"
            :label="$nova.labelsName('cycle_page','country_label','Country')"
            :items="countrylist"
            :selected="selectedcountry"
            :top-items="topcountrylist"
            :search-value="countrysearch"
            :loading="showLoader"
            @change="changeCountry"
            @update:searchValue="onCountrySearch"
            :multi-select="showmulticountry"
          />
          <div v-if="showcountry"><div class="filter-divider"></div></div>
          <FilterTypes
            type="rutype"
            :show="showrutype"
            :label="$nova.labelsName('cycle_page','type_label','RU Type')"
            :items="typeFilterItems"
            :selected="selectedReportingUnitType"
            :loading="showLoader" 
             @change="changeReportingUnitType"
            />
          <div v-if="showrutype"><div class="filter-divider"></div></div>
          <FilterTypes
            type="reporting-unit"
            :show="showreportingunit"
            :label="$nova.labelsName('cycle_page','ru_entity_label','Reporting Unit')"
            :items="reportingunitlist"
            :selected="selectedreportingunit"
            :top-items="topReportingUnitList"
            :search-value="searchReportingUnits"
            :loading="showLoader"
            :api-loading="reportingunitapiloading"
            :no-data-text="noreportunit"
            @change="changeReportingUnit"
            :multi-select="showmultireportingunit"
            @update:searchValue="onReportingUnitSearch"
          />

          <div v-if="showreportingunit"><div class="filter-divider"></div></div>
          <FilterTypes
            type="requesttype"
            :show="showrequesttype"
            :label="$nova.labelsName('cycle_page','request_type_label','Request Type')"
            :items="requesttypelist"
            :selected="selectedrequesttype"
            :loading="showLoader"
            @change="changeRequestType"
            :multi-select="showmultirequesttype"
          />
          <div v-if="showrequesttype"><div class="filter-divider"></div></div>
           <FilterTypes
            type="module"
            :show="showmodule"
            :label="$nova.labelsName('cycle_page','module_label','Module')"
            :items="modulelist"
            :selected="selectedmodule"
            :loading="showLoader"
            @change="changeModule"
          />
           <div v-if="showmodule"><div class="filter-divider"></div></div>
           <FilterTypes
            type="approvalstatus"
            :show="showapprovalstatus"
            :label="$nova.labelsName('cycle_page','approval_status_label','Approval Status')"
            :items="approvalstatuslist"
            :selected="selectedapprovalstatus"
            :loading="showLoader"
            @change="changeApprovalStatus"
            :multi-select="showmultiapprovalstatus"
          />
        </div>
        
        <!-- Added Buttons -->
        <div class="d-flex align-center gap-2">
          <div v-if="showapprovalstatus"><div class="filter-divider"></div></div>
          
          <!-- Report Generation Confirmation Menu -->
          <v-menu
            v-model="showReportGenerationMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition"
            min-width="320"
            max-width="360"
            data-testid="variance-analysis-filter__report-generation-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <base-button
                v-if="showApply"
                apply
                class="white--text"
                :class="{ 'apply-btn--pending': hasPendingApply }"
                depressed
                :loading="isApplyButtonLoading"
                :disabled="isApplyButtonLoading"
                @click="handleApplyFilters"
                data-testid="variance-analysis-filter__apply-button"
                :label="applyButtonText"
              />
            </template>
            
            <!-- Confirmation Popup Card -->
            <v-card class="report-generation-menu__card" data-testid="variance-analysis-filter__report-generation-card">
              <v-card-title class="report-generation-menu__header pa-2 primary">
                <span class="font-weight-bold">Generate Reports</span>
                <v-spacer></v-spacer>
                <v-btn icon small @click="cancelReportGeneration">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              
              <v-divider></v-divider>
              <v-card-text class="pa-2 d-flex flex-column gap-2">
                <!-- Info Chip -->
                <v-chip
                  outlined
                  class="pa-2"
                >
                  <v-icon left>mdi-information-outline</v-icon>
                  <span>Section Logic applied based on Reporting Units</span>
                </v-chip>

                <div class="font-weight-semibold">Select Module Type</div>
                
                <!-- Module Type Selection -->
                <v-radio-group 
                  v-model="reportGenerationType" 
                  class="module-radio-group d-flex flex-column gap-2 ma-0"
                  hide-details
                >
                  <div 
                    v-for="option in reportGenerationOptions" 
                    :key="option.value"
                    class="radio-card-wrapper"
                    :class="{ 'radio-card-wrapper--selected': reportGenerationType === option.value }"
                    @click="reportGenerationType = option.value"
                  >
                  <span class="radio-text">{{ option.label }}</span>
                    <v-radio
                      :value="option.value"
                      class="module-radio"
                      color="primary"
                      hide-details
                    />
                  </div>
                </v-radio-group>
              </v-card-text>
              
              <v-divider></v-divider>
              
              <v-card-actions class="pa-2 d-flex justify-end gap-2">
                <base-button
                  secondary
                  @click="cancelReportGeneration"
                  label="Cancel"
                  data-testid="variance-analysis-filter__cancel-report-btn"
                />
                <base-button
                  primary
                  :disabled="!reportGenerationType"
                  @click="confirmReportGeneration"
                  label="Confirm & Generate"
                  data-testid="variance-analysis-filter__confirm-report-btn"
                />
              </v-card-actions>
            </v-card>
          </v-menu>
          
          <FavouriteFiltersMenu
            v-if="showFavourite"
            :favourite-context="favouriteContext"
            :lookup-maps="favouriteLookupMaps"
            @select-favourite="handleFavouriteSelect"
          />
        </div>

        <!-- Sync now button emits event to parent for manual filter refresh -->
        <div v-if="showSync">
           <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="$emit('manual-filter-refresh')"
                v-bind="attrs"
                v-on="on"
                class=""
                icon
                data-testid="variance-analysis-filter__sync-now-btn"
              >
                <img :class="{ 'rotate': false }" class="icon" src="/img/icons/Sync.svg" alt="Sync Icon">
              </v-btn>
            </template>
            <span>Sync now</span>
          </v-tooltip>
        </div>

        <!-- Filters Reset -->
        <div class="text-center px-1" v-if="showReset">
          <div>
            <v-tooltip bottom content-class="tooltip-bottom">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="setValue('reload', true)"
                  data-testid="variance-analysis-filter__reset-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Reset filters</span>
            </v-tooltip>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import FilterTypes from './Analysis/components/FilterTypes.vue';
import FavouriteFiltersMenu from './Analysis/components/FavouriteFiltersMenu.vue';
import {
  ACTUAL_FILTER_STORAGE_KEY,
  FORECAST_FILTER_STORAGE_KEY,
  ACTUAL_HIERARCHY_STORAGE_KEY,
  FORECAST_HIERARCHY_STORAGE_KEY,
  BASE_PAGE_STATE_STORAGE_KEY,
  FILTER_MODULE_LIST,
  FILTER_MODULES_ARRAY,
  FILTER_ROLE_LIST,
  FILTER_ROLES_ARRAY,
  FILTER_MATERIALITY_LIST,
  FILTER_MATERIALITY_ARRAY,
  FILTER_CYCLE_LIST,
  FILTER_CYCLE_ARRAY,
  FILTER_REQUEST_TYPE_LIST,
  FILTER_REQUEST_TYPES_ARRAY,
  FILTER_APPROVAL_STATUS_LIST,
  FILTER_APPROVAL_STATUS_ARRAY,
  FILTER_DEFAULTS,
} from '../utils/constants';

export default {
  name: 'commentaryworking',
  components: {
    FilterTypes,
    FavouriteFiltersMenu,
  },
  data: function(){
    return {
      // Determines if N/R/C were auto-selected by RU inference
      isHierarchyInferred: false,
      
      pageName:"cycle_page",
      loading: false,
      hierarchyData: {},
      selectedrole: "",
      role: [],
      rolelist: {},
      selectedyear: "",
      year: [],
      possibleyear: [],
      yearlist: {},
      selectedperiod: "",
      period: [],
      possibleperiod: [],
      periodlist: {},
      allperiod: [],
      selectednetwork: "",
      networksearch: "",
      network: [],
      networklist: {},
      rutypes: [],
      rutypelist: {},
      selectedrutype: "all",
      modules: [],
      modulelist: {},
      selectedmodule: "all",
      materialitytypes: [],
      materialitylist: {},
      selectedmateriality: FILTER_DEFAULTS.SELECTED_MATERIALITY,
      cycletypes: [],
      cycletypelist: {},
      selectedcycletype: FILTER_DEFAULTS.SELECTED_CYCLETYPE,
      requesttypes: [...FILTER_REQUEST_TYPES_ARRAY],
      requesttypelist: { ...FILTER_REQUEST_TYPE_LIST },
      selectedrequesttype: "all",
      approvalstatuses: [...FILTER_APPROVAL_STATUS_ARRAY],
      approvalstatuslist: { ...FILTER_APPROVAL_STATUS_LIST },
      selectedapprovalstatus: "all",
      newnetworklist: {},
      selectedregion: "",
      regionsearch: "",
      region: [],
      possibleregion: [],
      regionlist: {},
      newregionlist: {},
      selectedcountry: "",
      countrysearch: "",
      country: [],
      possiblecountry: [],
      countrylist: {},
      newcountrylist: {},
      selectedreportingunit: "",
      reportingUnitTypes: "all",
      reportingUnitTypeList: { all: { _id: 'all', name: 'All' } },
      selectedReportingUnitType: "all",
      searchReportingUnits: "",
      debouncedRUsearch: "",
      debounceTimer: null,
      reportingunit: [],
      possiblereportingunit: [],
      reportingunitlist: {},
      newreportingunitlist: {},
      appname: "",
      alldata: {"_id": "all", "name": "All"},
      isReportSelected:false,
      previousFilterState: { 'selectednetwork': 'all', 'selectedreportingunit': 'all', 'selectedregion': 'all', 'selectedcountry': 'all', 'emit': true },
      filterStatus:[],
      reportingunitapiloading:false,
      noreportunit:'',
      skipPeriodRecalc: false, // Flag to skip period recalculation when restoring filters
      filterRequestToken: null, // Used to track latest filter API request
      lastAppliedFilters: null,
      hasPendingApply: false,
      isApplyLoading: false,
      pendingFilterRestore: null,
      pendingExternalReportingUnit: null,
      lastEmittedFilterSignature: null,
      // Report generation confirmation popup
      showReportGenerationMenu: false,
      reportGenerationType: '',
      reportGenerationOptions: [
        { label: 'Profit and Loss', value: 'pl' },
        { label: 'Balance Sheet', value: 'bs' }
      ]
    }
  },
  props: {
    cycletype: {
      type: String,
      default: ""
    },
    showrole: {
      type: Boolean,
      default: true
    },
    showyear: {
      type: Boolean,
      default: true
    },
    showperiod: {
      type: Boolean,
      default: true
    },
    shownetwork: {
      type: Boolean,
      default: true
    },
    showregion: {
      type: Boolean,
      default: true
    },
    showcountry: {
      type: Boolean,
      default: true
    },
    showrutype: {
      type: Boolean,
      default: true
    },
    showreportingunit: {
      type: Boolean,
      default: true
    },
    showmodule: {
      type: Boolean,
      default: false
    },
    showmateriality: {
      type: Boolean,
      default: false
    },
    showcycletype: {
      type: Boolean,
      default: false
    },
    showrequesttype: {
      type: Boolean,
      default: false
    },
    showapprovalstatus: {
      type: Boolean,
      default: false
    },
    showmultirole: {
      type: Boolean,
      default: false
    },
    showmultinetwork: {
      type: Boolean,
      default: false
    },
    showmultiregion: {
      type: Boolean,
      default: false
    },
    showmulticountry: {
      type: Boolean,
      default: false
    },
    showmultireportingunit: {
      type: Boolean,
      default: false
    },
    showmultirequesttype: {
      type: Boolean,
      default: false
    },
    showmultiapprovalstatus: {
      type: Boolean,
      default: false
    },
    showmultiperiod: {
      type: Boolean,
      default: false
    },
    showApply: {
      type: Boolean,
      default: true
    },
    showFavourite: {
      type: Boolean,
      default: true
    },
    showSync: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: false
    },
    asadmin: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    applyButtonText: {
      type: String,
      default: 'Apply'
    },
    reportingunitconfirmation: {
      type: Boolean,
      default: false
    }
  },
  activated() {
  },
  mounted() {
    this.appname = "m_" + (this.$route.path || "").split("/")[1] || "";
    this.refreshData();
  },
  beforeDestroy() {
    this.resetComponentState();
  },
  watch: {
    cycletype(val) {
      if(val) this.refreshData();
    },
    /**
     * Watch isLoading prop to reset isApplyLoading when parent API call completes
     * This ensures Apply button stays disabled until getreportingunitpagination/getreportinunitdata finishes
     */
    isLoading(newVal) {
      if (!newVal && this.isApplyLoading) {
        this.isApplyLoading = false;
      }
    },
    searchReportingUnits(val) {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      if (!val || val.length < 3) {
        this.reportingunitapiloading = false;
        this.newreportingunitlist = { ...this.reportingunitlist };
        this.debouncedRUsearch = '';
        return;
      }
      this.debounceTimer = setTimeout(() => {
        this.reportingunitapiloading = true;
        this.fetchReportingUnitsForSearch(val);
        this.debouncedRUsearch = val;
      }, 500); // 500ms debounce for smoother UX
    },
    selectedyear: function(){
      if (this.skipPeriodRecalc) {
        this.skipPeriodRecalc = false;
        return;
      }
      this.recalculatePeriod();
    },
  },
  methods: {
    resetComponentState() {
      // Reset filter selections
      this.selectedmodule = 'all';
      this.selectedmateriality = FILTER_DEFAULTS.SELECTED_MATERIALITY;
      this.selectedcycletype = FILTER_DEFAULTS.SELECTED_CYCLETYPE;
      this.selectedrequesttype = 'all';
      this.selectedapprovalstatus = 'all';
      this.selectedrutype = 'all';
      this.selectedReportingUnitType = 'all';
      this.selectednetwork = 'all';
      this.selectedregion = 'all';
      this.selectedcountry = 'all';
      this.selectedreportingunit = 'all';
      this.selectedperiod = '';
      this.selectedyear = '';
      this.selectedrole = 'all';
      this.networksearch = '';
      this.regionsearch = '';
      this.countrysearch = '';
      this.searchReportingUnits = '';
      
      // Clean up timers and flags
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      this.filterRequestToken = null;
      this.isApplyLoading = false;
      this.hasPendingApply = false;
      this.lastEmittedFilterSignature = null;
    },
    changeReportingUnitType(typeId) {
      if (this.selectedReportingUnitType === typeId) return;
      this.selectedReportingUnitType = typeId;
      // You can add additional logic here to filter reporting units by type if needed
      this.markFiltersPending();
      this.isReportSelected = true;
      this.setDropdowns(true);
    },
    changeRUType(typeId) {
      this.selectedrutype = typeId;
      this.markFiltersPending();
    },
    changeModule(moduleId) {
      this.selectedmodule = moduleId;
      this.markFiltersPending();
    },
    changeMateriality(materialityId) {
      this.selectedmateriality = materialityId;
      this.markFiltersPending();
    },
    changeCycletype(cycletypeId) {
      this.selectedcycletype = cycletypeId;
      this.markFiltersPending();
    },
    changeRequestType(requesttypeId) {
      this.selectedrequesttype = requesttypeId;
      this.markFiltersPending();
    },
    changeApprovalStatus(approvalstatusId) {
      this.selectedapprovalstatus = approvalstatusId;
      this.markFiltersPending();
    },
    changeRole(value){
      this.selectedrole = value;
      this.markFiltersPending();
    },
    onNetworkSearch(value) {
      this.networksearch = value || '';
    },
    onRegionSearch(value) {
      this.regionsearch = value || '';
    },
    onCountrySearch(value) {
      this.countrysearch = value || '';
    },
    onReportingUnitSearch(value) {
      this.searchReportingUnits = value || '';
    },
    ensureValidYear(yearValue = this.selectedyear) {
      const fallbackYear = this.year[0]?._id || this.selectedyear || '';
      const normalizedYear = yearValue && yearValue !== 'all' ? yearValue : fallbackYear;
      return normalizedYear || '';
    },
    // Snapshot of current filters for comparison against last applied state
    collectCurrentFilters() {
      return {
        selectedyear: this.ensureValidYear(),
        selectedperiod: this.selectedperiod,
        selectedrole: this.selectedrole,
        selectednetwork: this.selectednetwork,
        selectedregion: this.selectedregion,
        selectedcountry: this.selectedcountry,
        selectedreportingunit: this.selectedreportingunit,
        selectedReportingUnitType: this.selectedReportingUnitType,
        selectedrutype: this.selectedrutype,
        selectedmodule: this.selectedmodule,
        selectedmateriality: this.selectedmateriality,
        selectedcycletype: this.selectedcycletype,
        selectedrequesttype: this.selectedrequesttype,
        selectedapprovalstatus: this.selectedapprovalstatus,
      };
    },
    getFilterSignature() {
      const snapshot = this.collectCurrentFilters();
      return JSON.stringify(snapshot);
    },
    areFiltersEqual(snapshotA, snapshotB) {
      if (!snapshotA || !snapshotB) {
        return false;
      }
      const keys = Object.keys(snapshotA);
      for (const key of keys) {
        if (snapshotA[key] !== snapshotB[key]) {
          return false;
        }
      }
      return true;
    },
    // Flag apply button when filters diverge from the last applied snapshot
    markFiltersPending() {
      const currentSnapshot = this.collectCurrentFilters();
      this.hasPendingApply = !this.areFiltersEqual(currentSnapshot, this.lastAppliedFilters);
    },
    resolveHierarchyId(value) {
      if (value === null || value === undefined) {
        return '';
      }
      if (typeof value === 'string' || typeof value === 'number') {
        return value;
      }
      if (typeof value === 'object') {
        // Handle array wrapper case (some APIs return an array of 1 object)
        if (Array.isArray(value) && value.length > 0) {
           return this.resolveHierarchyId(value[0]);
        }
        return value._id || value.id || value.value || value.code || '';
      }
      return '';
    },
    normalizeExternalReportingUnit(detail = {}, context = {}) {
      const resolvedId = this.resolveHierarchyId(detail) || this.resolveHierarchyId(context.reportingunit);
      if (!resolvedId) {
        return null;
      }
      const code = detail.code || detail.rucode || detail.reportingunitcode || detail.reporting_unit_code || '';
      const rawName = detail.name || detail.reportingunitname || detail.reporting_unit_name || detail.label || '';
      const displayName = [code, rawName].filter(Boolean).join(' - ') || rawName || code || String(resolvedId);
      
      // Improve resolution by checking multiple sources for network/region/country
      // Prioritize details from the object itself, then context
      const network = this.resolveHierarchyId(detail.network_detail || detail.network) || 
                      this.resolveHierarchyId(context.network_detail || context.network);
                      
      const region = this.resolveHierarchyId(detail.region_detail || detail.region) || 
                     this.resolveHierarchyId(context.region_detail || context.region);
                     
      const country = this.resolveHierarchyId(detail.country_detail || detail.country) || 
                      this.resolveHierarchyId(context.country_detail || context.country);


      const cycle = detail.cycle || detail.cycle_id || detail.cycleId || '';
      return {
        _id: resolvedId,
        name: displayName,
        code,
        cycle,
        network,
        region,
        country,
        rawName,
        type: detail.type || detail.rutype || detail.ru_type || context.rutype || context.type
      };
    },
    upsertReportingUnitFromExternal(normalized) {
      if (!normalized || !normalized._id) {
        return;
      }
      const ruId = normalized._id;
      const ruEntry = {
        _id: ruId,
        name: normalized.name,
        code: normalized.code,
        cycle: normalized.cycle,
        type: normalized.type,
      };
      
      // Smart update for hierarchy fields
      if (normalized.network) ruEntry.network = normalized.network;
      if (normalized.region) ruEntry.region = normalized.region;
      if (normalized.country) ruEntry.country = normalized.country;
      
      // Update context only if we have values
      ruEntry.context = {
         type: normalized.type,
         ...((this.reportingunitlist?.[ruId]?.context) || {})
      };
      if (normalized.network) ruEntry.context.network = normalized.network;
      if (normalized.region) ruEntry.context.region = normalized.region;
      if (normalized.country) ruEntry.context.country = normalized.country;

      // Merge with existing entry if exists to preserve other props
      const existing = this.reportingunitlist?.[ruId] || {};
      
      // If existing has valid hierarchy data and new one doesn't, ensure we don't wipe it out
      // (Though the logic above using if(normalized.X) handles most key overwrites, 
      // strict null checks here add safety)
      const mergedEntry = { ...existing, ...ruEntry };
      
      const updatedMap = {
        ...this.reportingunitlist,
        [ruId]: mergedEntry,
      };
      this.reportingunitlist = updatedMap;
      this.newreportingunitlist = updatedMap;
      const hasAllEntry = Array.isArray(this.reportingunit) && this.reportingunit.some(item => item && item._id === this.alldata._id);
      const baseList = Array.isArray(this.reportingunit)
        ? this.reportingunit.filter(item => item && item._id && item._id !== this.alldata._id)
        : [];
      const existingIndex = baseList.findIndex(item => item._id === ruId);
      if (existingIndex === -1) {
        baseList.push({ ...ruEntry });
      } else {
        baseList.splice(existingIndex, 1, { ...baseList[existingIndex], ...ruEntry });
      }
      this.reportingunit = hasAllEntry ? [{ ...this.alldata }, ...baseList] : baseList;
      if (!this.hierarchyData) {
        this.hierarchyData = {};
      }
      if (!Array.isArray(this.hierarchyData.reportingunitlist)) {
        this.$set(this.hierarchyData, 'reportingunitlist', []);
      }
      const hierarchyEntry = {
        _id: ruId,
        code: normalized.code,
        name: normalized.rawName || normalized.name,
      };
      
      // Only include hierarchy fields if they are present in the update
      // This prevents overwriting existing data with empty values when partial data is received
      if (normalized.network) hierarchyEntry.network = normalized.network;
      if (normalized.region) hierarchyEntry.region = normalized.region;
      if (normalized.country) hierarchyEntry.country = normalized.country;

      const hierarchyIndex = this.hierarchyData.reportingunitlist.findIndex(item => item._id === ruId);
      if (hierarchyIndex === -1) {
        // If new, ensure we at least set what we have, defaulting to what's in normalized (even if empty) to match structure
        if (!Object.prototype.hasOwnProperty.call(hierarchyEntry, 'network')) hierarchyEntry.network = normalized.network || '';
        if (!Object.prototype.hasOwnProperty.call(hierarchyEntry, 'region')) hierarchyEntry.region = normalized.region || '';
        if (!Object.prototype.hasOwnProperty.call(hierarchyEntry, 'country')) hierarchyEntry.country = normalized.country || '';
        
        this.hierarchyData.reportingunitlist.push(hierarchyEntry);
      } else {
        this.$set(this.hierarchyData.reportingunitlist, hierarchyIndex, {
          ...this.hierarchyData.reportingunitlist[hierarchyIndex],
          ...hierarchyEntry,
        });
      }
    },
    registerExternalReportingUnit(detail, context = {}) {
      const normalized = this.normalizeExternalReportingUnit(detail || {}, context || {});
      if (!normalized) {
        this.pendingExternalReportingUnit = null;
        return;
      }
      this.upsertReportingUnitFromExternal(normalized);
      this.pendingExternalReportingUnit = {
        id: normalized._id,
        context: {
          network: normalized.network,
          region: normalized.region,
          country: normalized.country,
          type: normalized.type
        },
      };
    },
    /**
     * Resolve variance analysis Vuex state regardless of module namespace differences.
     * Provides a fallback to the root varianceanalysis module when the dynamic key is unavailable.
     */
    resolveVarianceModuleProperty(propertyName, fallbackValue = undefined) {
      const candidates = [
        this.$store.state?.[this.appname],
        this.$store.state?.varianceanalysis,
      ];
      for (const candidate of candidates) {
        if (candidate && Object.prototype.hasOwnProperty.call(candidate, propertyName)) {
          return candidate[propertyName];
        }
      }
      const storageKey = this.resolveStorageKey(propertyName);
      if (storageKey && typeof window !== 'undefined' && window.sessionStorage) {
        try {
          const storedValue = window.sessionStorage.getItem(storageKey);
          if (storedValue) {
            return JSON.parse(storedValue);
          }
        } catch (error) {
          console.warn(`[Filter]: Failed to parse session value for ${propertyName}`, error);
        }
      }
      return fallbackValue;
    },
    resolveStorageKey(propertyName) {
      switch (propertyName) {
        case 'actualfilter':
          return ACTUAL_FILTER_STORAGE_KEY;
        case 'forecastfilter':
          return FORECAST_FILTER_STORAGE_KEY;
        case 'actualhierarchydata':
          return ACTUAL_HIERARCHY_STORAGE_KEY;
        case 'forecasthierarchydata':
          return FORECAST_HIERARCHY_STORAGE_KEY;
        case 'basePageState':
          return BASE_PAGE_STATE_STORAGE_KEY;
        default:
          return null;
      }
    },
    // Apply filters and emit updates to the parent consumer
    handleApplyFilters() {
      if (this.isApplyButtonLoading) {
        return;
      }
      
      // Show confirmation popup when:
      // 1. reportingunitconfirmation prop is true
      // 2. Multiple reporting units are selected
      if (this.reportingunitconfirmation && this.hasMultipleReportingUnitsSelected) {
        this.reportGenerationType = ''; // Reset selection
        this.showReportGenerationMenu = true;
        return;
      }
      
      // Single RU or no confirmation needed - proceed directly
      this.proceedWithApplyFilters();
    },
    
    /**
     * Proceed with the actual filter application
     * @param {string|null} reportType - Selected report type ('pl' or 'bs') when confirmation is used
     */
    proceedWithApplyFilters(reportType = null) {
      // Note: isApplyLoading will be reset by the isLoading watcher when parent API call completes
      this.setDropdowns(false, true, reportType);
    },
    
    /**
     * Confirm report generation and apply filters
     */
    confirmReportGeneration() {
      if (!this.reportGenerationType) {
        return;
      }
      this.showReportGenerationMenu = false;
      this.proceedWithApplyFilters(this.reportGenerationType);
    },
    
    /**
     * Cancel report generation menu
     */
    cancelReportGeneration() {
      this.showReportGenerationMenu = false;
      this.reportGenerationType = '';
    },
    // Restore filters from the selected favourite and flag the apply button
    handleFavouriteSelect(favourite) {
      if (!favourite || typeof favourite !== 'object') {
        return;
      }
      const normalizeValue = (value, fallback = 'all') => {
        if (value === undefined || value === null || value === '') {
          return fallback;
        }
        if (typeof value === 'object') {
          return value._id || value.id || value.value || value.code || value.name || fallback;
        }
        return value;
      };
      const fallbackYear = this.selectedyear || this.year?.[0]?._id || '';
      const previousYear = this.selectedyear;
      const restoredFilters = {
        selectedyear: normalizeValue(favourite.year ?? favourite.selectedyear, fallbackYear),
        selectedperiod: normalizeValue(favourite.period ?? favourite.selectedperiod),
        selectednetwork: normalizeValue(favourite.network ?? favourite.selectednetwork),
        selectedregion: normalizeValue(favourite.region ?? favourite.selectedregion),
        selectedcountry: normalizeValue(favourite.country ?? favourite.selectedcountry),
        selectedreportingunit: normalizeValue(favourite.reportingunit ?? favourite.selectedreportingunit),
        emit: false,
      };
      this.skipPeriodRecalc = true;
      this.selectedReportingUnitType = normalizeValue(
        favourite.type ?? favourite.selectedReportingUnitType,
        'all'
      ) || 'all';
      this.setFilterItem(restoredFilters);
      const yearChanged = String(restoredFilters.selectedyear || '') !== String(previousYear || '');
      if (yearChanged) {
        this.populatePeriodListOnly();
      }
      if (restoredFilters.selectedperiod && this.periodlist?.[restoredFilters.selectedperiod]) {
        this.selectedperiod = restoredFilters.selectedperiod;
      }
      this.setDropdowns(true);
      this.markFiltersPending();
    },
    setReportingUnitWithContext(id, context) {
      this.pendingExternalReportingUnit = { id, context };
      this.setValue('selectedreportingunit', id);
    },
    setValue(key, value){
      if(key === 'reload'){
        this.resetFilters();
      } else {
        if (key === 'selectedreportingunit') {
            this.changeReportingUnit(value);
        } else if (key === 'selectedperiod') {
            this.changePeriod(value);
        } else if (key === 'selectednetwork') {
            this.changeNetwork(value);
        } else if (key === 'selectedregion') {
            this.changeRegion(value);
        } else if (key === 'selectedcountry') {
            this.changeCountry(value);
        } else if (key === 'selectedyear') {
            this.changeYear(value);
        } else if (this[key] !== undefined) {
            this[key] = value;
        }
      }
    },
    resetFilters(){
      this.selectedreportingunit = 'all';
      this.selectedcountry = 'all';
      this.selectedregion = 'all';
      this.selectednetwork = 'all';
      this.selectedrole = 'all';
      this.selectedReportingUnitType = 'all';
      this.selectedrutype = 'all';
      this.selectedmodule = 'all';
      this.selectedrequesttype = 'all';
      this.selectedapprovalstatus = 'all';
      this.selectedmateriality = FILTER_DEFAULTS.SELECTED_MATERIALITY;
      this.selectedcycletype = FILTER_DEFAULTS.SELECTED_CYCLETYPE;
      // this.reportingunit = []; // remove this line
      this.newreportingunitlist = { ...this.reportingunitlist }; // Reset filtered list to full list
      
      // Emit clear state once
      this.pendingFilterRestore = null;
      // Pass false to forceReload to prevent immediate API call in CycleReport
      this.setDropdowns(false, false);
    },
    // Fetch and process reporting units based on the provided search code using utils file.
    async fetchReportingUnitsForSearch(code) {
      if (!code || code.length < 3) return;
      this.reportingunitapiloading = true;
      try {
        await this.$store.dispatch(this.appname + "/searchReportingUnits", { code, axios: this.axios });
        const reportingUnits = this.$store.state[this.appname].reportingUnitSearchResults || [];
        this.noreportunit = reportingUnits.length === 0 ? "No Reporting Units" : "";
        this.newreportingunitlist = reportingUnits;
      } finally {
        this.reportingunitapiloading = false;
      }
    },
    refreshData() {
      // Check if we're coming back from GLBreakdown - skip getData if so
      if (this.$store.state.varianceanalysis?.skipReloadOnBack) {
        // Just restore filter values from store, don't call getData
        let existingfilter = this.cycletype === "Actual"
          ? (this.resolveVarianceModuleProperty('actualfilter', {}) || {})
          : (this.resolveVarianceModuleProperty('forecastfilter', {}) || {});
        
        // Also try to get from session storage as backup
        if (!existingfilter || Object.keys(existingfilter).length === 0) {
          const storageKey = this.cycletype === "Actual" ? ACTUAL_FILTER_STORAGE_KEY : FORECAST_FILTER_STORAGE_KEY;
          try {
            const storedFilter = sessionStorage.getItem(storageKey);
            if (storedFilter) {
              existingfilter = JSON.parse(storedFilter);
            }
          } catch (e) {
            console.warn('[Filter]: Failed to parse stored filter', e);
          }
        }
        
        if (!existingfilter || Object.keys(existingfilter).length === 0) {
          const savedBaseState = this.resolveVarianceModuleProperty('basePageState', {}) || {};
          existingfilter = {
            selectedyear: savedBaseState.selectedyear,
            selectedperiod: savedBaseState.selectedperiod,
            selectednetwork: savedBaseState.selectednetwork,
            selectedregion: savedBaseState.selectedregion,
            selectedcountry: savedBaseState.selectedcountry,
            selectedreportingunit: savedBaseState.selectedreportingunit,
          };
        }

        const savedContext = {
          role: existingfilter.selectedrole || '',
          year: existingfilter.selectedyear,
          period: existingfilter.selectedperiod,
          network: existingfilter.selectednetwork || '',
          region: existingfilter.selectedregion || '',
          country: existingfilter.selectedcountry || '',
          reportingunit: existingfilter.selectedreportingunit || '',
        };

        // Restore hierarchy data from store or fallback cache
        this.hierarchyData = this.cycletype === "Actual"
          ? (this.resolveVarianceModuleProperty('actualhierarchydata', {}) || {})
          : (this.resolveVarianceModuleProperty('forecasthierarchydata', {}) || {});
        if (!this.hierarchyData || Object.keys(this.hierarchyData).length === 0) {
          const savedBaseState = this.resolveVarianceModuleProperty('basePageState', {}) || {};
          if (savedBaseState.hierarchyData) {
            this.hierarchyData = savedBaseState.hierarchyData;
          }
        }

        const hasHierarchyData = Array.isArray(this.hierarchyData?.reportingunitlist) && this.hierarchyData.reportingunitlist.length > 0;
        if (!hasHierarchyData) {
          // Fallback: hydrate hierarchy via API so filters do not degrade to NA after refresh/back
          this.pendingFilterRestore = savedContext;
          this.getData();
          return;
        }


        this.applyRestoredFilters(savedContext);
        return;
      }
      
      // Reset all selections to default. 
      // Do NOT restore previous user selections from 'actualfilter' or 'forecastfilter'.
      // This ensures we only use the cached hierarchy data but reset the specific choices.
      this.selectedrole = "all";
      this.selectedyear = "";
      this.selectedperiod = "";
      this.selectednetwork = "all";
      this.selectedregion = "all";
      this.selectedcountry = "all";
      this.selectedreportingunit = "all";
      this.selectedReportingUnitType = "all";
      this.selectedrutype = "all";
      this.selectedmateriality = FILTER_DEFAULTS.SELECTED_MATERIALITY;
      this.selectedcycletype = FILTER_DEFAULTS.SELECTED_CYCLETYPE;

      this.pendingFilterRestore = null;
      this.lastAppliedFilters = {}; 

      this.getData(false);
    },
    setLocalFilterValues(){
      const sanitizedYear = this.ensureValidYear();
      let localcopy = {
        selectedrole: this.selectedrole,
        selectedyear: sanitizedYear,
        selectedperiod: this.selectedperiod,
        selectednetwork: this.selectednetwork,
        selectedregion: this.selectedregion,
        selectedcountry: this.selectedcountry,
        selectedreportingunit: this.selectedreportingunit,
        selectedReportingUnitType: this.selectedReportingUnitType,
        selectedrutype: this.selectedrutype,
        selectedmodule: this.selectedmodule,
      }
      // Save to Vuex store
      if(this.cycletype === "Actual") {
        this.$store.commit(this.appname + "/setActualFilters", localcopy);
        // Also save to sessionStorage for persistence across page refreshes
        try {
          sessionStorage.setItem(ACTUAL_FILTER_STORAGE_KEY, JSON.stringify(localcopy));
        } catch (e) {
          console.warn('[Filter]: Failed to save filter to sessionStorage', e);
        }
      } else if(this.cycletype === "Forecast") {
        this.$store.commit(this.appname + "/setForecastFilters", localcopy);
        try {
          sessionStorage.setItem(FORECAST_FILTER_STORAGE_KEY, JSON.stringify(localcopy));
        } catch (e) {
          console.warn('[Filter]: Failed to save filter to sessionStorage', e);
        }
      }
    },
    emitFilterState(reloadReportingUnit = false) {
      if (this.selectedreportingunit === undefined || this.selectedreportingunit === null || this.selectedreportingunit === '') {
        this.selectedreportingunit = 'all';
      }
      if (this.selectednetwork === undefined || this.selectednetwork === null || this.selectednetwork === '') {
        this.selectednetwork = 'all';
      }
      if (this.selectedregion === undefined || this.selectedregion === null || this.selectedregion === '') {
        this.selectedregion = 'all';
      }
      if (this.selectedcountry === undefined || this.selectedcountry === null || this.selectedcountry === '') {
        this.selectedcountry = 'all';
      }
      this.sendEvent("role", this.role);
      this.sendEvent("rolelist", this.rolelist);
      this.sendEvent("selectedrole", this.selectedrole);
      this.sendEvent("year", this.year);
      this.sendEvent("yearlist", this.yearlist);
      this.sendEvent("selectedyear", this.selectedyear);
      this.sendEvent("period", this.period);
      this.sendEvent("periodlist", this.periodlist);
      this.sendEvent("selectedperiod", this.selectedperiod);
      this.sendEvent("network", this.network);
      this.sendEvent("networklist", this.networklist);
      this.sendEvent("selectednetwork", this.selectednetwork);
      this.sendEvent("region", this.region);
      this.sendEvent("regionlist", this.regionlist);
      this.sendEvent("selectedregion", this.selectedregion);
      this.sendEvent("country", this.country);
      this.sendEvent("countrylist", this.countrylist);
      this.sendEvent("selectedcountry", this.selectedcountry);
      this.sendEvent("rutypes", this.rutypes);
      this.sendEvent("rutypelist", this.rutypelist);
      this.sendEvent("selectedrutype", this.selectedrutype);
      this.sendEvent("modules", this.modules);
      this.sendEvent("modulelist", this.modulelist);
      this.sendEvent("selectedmodule", this.selectedmodule);
      this.sendEvent("materialitytypes", this.materialitytypes);
      this.sendEvent("materialitylist", this.materialitylist);
      this.sendEvent("selectedmateriality", this.selectedmateriality);
      this.sendEvent("cycletypes", this.cycletypes);
      this.sendEvent("cycletypelist", this.cycletypelist);
      this.sendEvent("selectedcycletype", this.selectedcycletype);
      this.sendEvent("reportingunit", this.reportingunit);
      this.sendEvent("reportingunitlist", this.reportingunitlist);
      this.sendEvent("selectedreportingunit", this.selectedreportingunit, reloadReportingUnit);
      this.$emit('newdata', {key: 'loading', value: false});
    },
    applyRestoredFilters(context = {}) {
      const {
        role = '',
        year = '',
        period = '',
        network = '',
        region = '',
        country = '',
        reportingunit = '',
      } = context;

      this.pendingFilterRestore = null;
      this.skipPeriodRecalc = true;

      this.selectedrole = role;
      this.selectedyear = this.ensureValidYear(year);
      this.selectedperiod = period;
      this.selectednetwork = (network !== undefined && network !== null && network !== '') ? network : 'all';
      this.selectedregion = (region !== undefined && region !== null && region !== '') ? region : 'all';
      this.selectedcountry = (country !== undefined && country !== null && country !== '') ? country : 'all';
      this.selectedreportingunit = (reportingunit !== undefined && reportingunit !== null && reportingunit !== '') ? reportingunit : 'all';

      const hasHierarchy = Array.isArray(this.hierarchyData?.reportingunitlist) && this.hierarchyData.reportingunitlist.length > 0;
      if (hasHierarchy) {
        // Preserve selection and prevent duplicate emits while rebuilding dropdowns
        this.populateAccessHierarchy(true, true);
      }

      this.emitFilterState();
      this.lastAppliedFilters = this.collectCurrentFilters();
      this.hasPendingApply = false;
      if (!hasHierarchy) {
        this.setLocalFilterValues();
      }
    },
    sendEvent: function(k,value, reload=false) {
      if (k === 'selectedyear') {
        value = this.ensureValidYear(value);
      }
      if (k === 'selectedreportingunit') {
        const signature = this.getFilterSignature();
        
        // Check global signature from sessionStorage to prevent duplicate loads across page navigations
        const storageKey = `butterfly_filter_signature_${this.cycletype}`;
        const globalSignature = sessionStorage.getItem(storageKey);
        
        const signatureChanged = signature !== this.lastEmittedFilterSignature && signature !== globalSignature;
        
        /* if (!signatureChanged && reload) {
          reload = false;
        } */
        
        if (signatureChanged) {
          this.lastEmittedFilterSignature = signature;
          try {
            sessionStorage.setItem(storageKey, signature);
          } catch (e) {
            console.warn('[Filter.sendEvent] Failed to save signature to sessionStorage', e);
          }
        }
      }
      this.$emit('newdata', {key: k, value: value, reload: reload});
    },
    getData(manualRefresh=false) {
      if(!manualRefresh) {
        let cachedData = {};
        if(this.cycletype === "Actual") cachedData = this.$store.state[this.appname].actualhierarchydata;
        else if(this.cycletype === "Forecast") cachedData = this.$store.state[this.appname].forecasthierarchydata;

        // Fallback: check the 'varianceanalysis' store module (used by Materiality & Access Management)
        if (!cachedData || Object.keys(cachedData).length === 0) {
          const fallbackState = this.$store.state.varianceanalysis || {};
          if(this.cycletype === "Actual") cachedData = fallbackState.actualhierarchydata;
          else if(this.cycletype === "Forecast") cachedData = fallbackState.forecasthierarchydata;
        }

        if (cachedData && Object.keys(cachedData).length > 0 && Array.isArray(cachedData.reportingunitlist) && cachedData.reportingunitlist.length > 0) {
           this.hierarchyData = cachedData;
           if (this.pendingFilterRestore) {
              const context = { ...this.pendingFilterRestore };
              this.applyRestoredFilters(context);
           } else {
              this.populateAccessHierarchy();
           }
           this.$emit('newdata', {key: 'loading', value: false});
           this.loading = false;
           return;
        }
      }

      // Create a unique token for this request to handle race conditions
      const requestToken = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      this.filterRequestToken = requestToken;

      this.loading = true;
      this.$emit('newdata', {key: 'loading', value: true});
      
      let filter={"filter":{"cycletype":this.cycletype,"type":"ru","role":"all","network":"all","region":"all","country":"all","reportingunit":"all"}}
      if(manualRefresh){
        filter.filter['sync_type']="manual"
      }

      this.$store.dispatch(this.appname + "/fetchAccessHierarchy", { 
          axios: this.axios, 
          filter: filter, 
          manualRefresh: manualRefresh 
      }).then(response => {
          // Only update if this is the latest request
          if (this.filterRequestToken !== requestToken) return;
          
          if (response && (response.status === "success" || response.fromCache)) {
             let data = {};
             if(this.cycletype === "Actual") data = this.$store.state[this.appname].actualhierarchydata;
             else if(this.cycletype === "Forecast") data = this.$store.state[this.appname].forecasthierarchydata;

             if (!data || Object.keys(data).length === 0) {
                 const savedBaseState = this.resolveVarianceModuleProperty('basePageState', {}) || {};
                 if (savedBaseState.hierarchyData) {
                    data = savedBaseState.hierarchyData;
                 }
             }

             if (!data) throw new Error("Invalid data received");
             this.hierarchyData = data;
             
             if (this.pendingFilterRestore) {
                const context = { ...this.pendingFilterRestore };
                this.applyRestoredFilters(context);
             } else {
                this.populateAccessHierarchy();
             }
             this.$emit('isDataSynced',{'syncCompleted':false})
          } else {
               throw new Error(response && response.message ? response.message : "Error fetching data");
          }
      }).catch(err => {
         if (this.filterRequestToken !== requestToken) return;
          this.$store.commit("sbError", err.message || err || "Unknown error!", { root: true });
          console.error('[Filter]: getData error', err);
      }).finally(() => {
          if (this.filterRequestToken !== requestToken) return;
          this.loading = false;
          this.$emit('newdata', {key: 'loading', value: false});
      });
    },
    populateAccessHierarchy(preserveSelection = false, stopEmit = false) {
      let data = {...this.hierarchyData};
      this.$store.commit(this.appname + "/setFilters", this.hierarchyData);
      
      const typesFromApi = Array.isArray(data.reportingUnitTypes) && data.reportingUnitTypes.length > 0
        ? data.reportingUnitTypes 
        : ['ru', 'jv'];

      this.reportingUnitTypeList = {
        all: { _id: 'all', name: 'All' },
        ...(typesFromApi.reduce((acc, type) => {
          let label = type === 'jv' ? 'JV' : type === 'ru' ? 'RU' : type.toUpperCase();
          acc[type] = { _id: type, name: label };
          return acc;
        }, {}))
      };
      
      // Populate rutypes array for consistency and usage in setDropdowns
      this.rutypes = Object.values(this.reportingUnitTypeList).filter(t => t._id !== 'all');

      if (!this.selectedReportingUnitType || !this.reportingUnitTypeList[this.selectedReportingUnitType]) {
        this.selectedReportingUnitType = FILTER_DEFAULTS.SELECTED_RU_TYPE;
      }
      // Initialize Module Types (P&L, Balance Sheet) from constants
      this.modulelist = { ...FILTER_MODULE_LIST };
      this.modules = [...FILTER_MODULES_ARRAY];
      if (!this.selectedmodule || !this.modulelist[this.selectedmodule]) {
        this.selectedmodule = FILTER_DEFAULTS.SELECTED_MODULE;
      }

      // Initialize Materiality Types from constants
      this.materialitylist = { ...FILTER_MATERIALITY_LIST };
      this.materialitytypes = [...FILTER_MATERIALITY_ARRAY];
      if (!this.selectedmateriality || !this.materialitylist[this.selectedmateriality]) {
        this.selectedmateriality = FILTER_DEFAULTS.SELECTED_MATERIALITY;
      }

      // Initialize Cycle Types from constants
      this.cycletypelist = { ...FILTER_CYCLE_LIST };
      this.cycletypes = [...FILTER_CYCLE_ARRAY];
      if (!this.selectedcycletype || !this.cycletypelist[this.selectedcycletype]) {
        this.selectedcycletype = FILTER_DEFAULTS.SELECTED_CYCLETYPE;
      }

      // Initialize Request Types from constants
      this.requesttypelist = { ...FILTER_REQUEST_TYPE_LIST };
      this.requesttypes = [...FILTER_REQUEST_TYPES_ARRAY];
      if (!this.selectedrequesttype || !this.requesttypelist[this.selectedrequesttype]) {
        this.selectedrequesttype = FILTER_DEFAULTS.SELECTED_REQUEST_TYPE;
      }

      // Initialize Approval Status from constants
      this.approvalstatuslist = { ...FILTER_APPROVAL_STATUS_LIST };
      this.approvalstatuses = [...FILTER_APPROVAL_STATUS_ARRAY];
      if (!this.selectedapprovalstatus || !this.approvalstatuslist[this.selectedapprovalstatus]) {
        this.selectedapprovalstatus = FILTER_DEFAULTS.SELECTED_APPROVAL_STATUS;
      }

      // Initialize Roles from constants
      this.rolelist = { ...FILTER_ROLE_LIST };
      this.role = [...FILTER_ROLES_ARRAY];
      if (!this.selectedrole || !this.rolelist[this.selectedrole]) {
        this.selectedrole = FILTER_DEFAULTS.SELECTED_ROLE;
      }

      let rulist = data.reportingunitlist || [];
      let usedid = [];

      
      // set year
      this.year = [];
      usedid = [];
      this.yearlist = {};
      
      // Use a copy to avoid mutating store state
      const yearListCopy = [...(data.yearlist || [])].reverse((a,b) => a-b);
      
      // Add 'All' year option
      this.year.push({_id: 'all', name: 'All'});
      this.yearlist['all'] = {_id: 'all', name: 'All'};
      for (let i = 0; i < (yearListCopy || []).length; i++) {
        const el = yearListCopy[i];
        if(usedid.indexOf(el) === -1 && el._id !== "all"){
          let nd = {_id: el, name: el}
          usedid.push(el);
          this.year.push(nd)
          this.yearlist[el] = nd;
        }
      }
      this.year = this.year.sort((a,b) =>  b.name - a.name);
      
      // Use a copy to avoid mutating store state
      const periodListCopy = [...(data.periodlist || [])].sort((a, b) => a.year - b.year || a.number - b.number);

      if (preserveSelection) {
        if (!this.selectedyear || !this.yearlist[this.selectedyear]) {
          this.selectedyear = this.year[0]?._id || '';
        }
      }

      // Only reset selectedyear and selectedperiod if not preserving selection
      if (!preserveSelection) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        const filteredItems = periodListCopy.filter(item =>
          item.year < currentYear || (item.year === currentYear && item.number <= currentMonth)
        );
        if(filteredItems.length > 0){
          this.selectedyear = filteredItems[filteredItems.length-1].year;
          this.selectedperiod = filteredItems[filteredItems.length-1]._id;
        }else if( periodListCopy && periodListCopy.length > 0){
          this.selectedyear = periodListCopy[0].year;
          this.selectedperiod = periodListCopy[0]._id;
        }else if(this.year.length > 0) {
          // Fallback: pick the first available year
          this.selectedyear = this.year[0]._id;
          this.selectedperiod = '';
        }else{
          this.selectedyear = '';
          this.selectedperiod = '';
        }
      }


      // set period 
      //usedid = [];
      this.allperiod = periodListCopy || [];
      // Only recalculate period if not preserving selection
      if (!preserveSelection) {
        this.recalculatePeriod();
      } else {
        // Just populate periodlist without changing selectedperiod
        this.populatePeriodListOnly();
      }
      // set network
      this.network = data.networklist || [];
      this.networklist = {};
      for (const i of this.network) {
        this.networklist[i._id] = i;
      }
      if(this.network.length > 1){
        this.network.unshift({...this.alldata});
        this.networklist[this.alldata._id] = {...this.alldata};
      }
      this.newnetworklist = this.networklist;

      // set region
      this.region = data.regionlist || [];
      this.regionlist = {};
      for (const i of this.region) {
        this.regionlist[i._id] = i;
      }
      if(this.region.length > 1){
        this.region.unshift({...this.alldata});
        this.regionlist[this.alldata._id] = {...this.alldata};
      }
      this.newregionlist = this.regionlist;

      // set country
      this.country = data.countrylist || [];
      this.countrylist = {};
      for (const i of this.country) {
         this.countrylist[i._id] = i;
      }
      if(this.country.length > 1){
        this.country.unshift({...this.alldata});
        this.countrylist[this.alldata._id] = {...this.alldata};
      }
      this.newcountrylist = this.countrylist;

      // set reportingunit
      usedid = [];
      this.reportingunit = [];
      this.reportingunitlist = {};

      for (const i of rulist) {
        if(usedid.indexOf(i._id) === -1){
          // Aggressively search for any field that might hold the type
          const resolvedType = i.type || i.rutype || i.ru_type || i.unit_type || i.entity_type || (i.context ? i.context.type : null);
          
          let nd = {
            _id: i._id, 
            name: i.code + " - " + i.name, 
            cycle: i.cycle,
            type: resolvedType,
            rutype: resolvedType,
            network: i.network,
            region: i.region,
            country: i.country,
            // Keep original context just in case
            context: i.context
          }
          usedid.push(i._id);
          this.reportingunit.push(nd)
          this.reportingunitlist[i._id] = nd;
        }
      }
     
      for (const i of this.reportingunit) {
         this.reportingunitlist[i._id] = i;
      }
      if(this.reportingunit.length > 0){
        this.reportingunit.unshift({...this.alldata});
        this.reportingunitlist[this.alldata._id] = {...this.alldata};
      }
      this.newreportingunitlist = this.reportingunitlist;
      

      this.setDropdowns(stopEmit);
    },
    setDropdowns(stopemitflag = false, forceReload = false, reportType = null){
      // set defaults
      if(this.role.length === 1) this.selectedrole = this.role[0]._id;
      else this.selectedrole = this.selectedrole || "all";
      if (this.year.length === 1) {
        this.selectedyear = this.year[0]._id;
      }
      this.selectedyear = this.ensureValidYear(this.selectedyear);
      if(this.period.length === 1) this.selectedperiod = this.period[0]._id;
      else if (!this.selectedperiod || this.selectedperiod === 'all') {
        // Only reset period if it's empty or 'all' - preserve valid period IDs even if not in periodlist
        // This prevents selectedperiod from being reset when navigating back from GL breakdown
        const firstAvailablePeriod = this.period.find(p => p._id && p._id !== this.alldata._id);
        this.selectedperiod = firstAvailablePeriod?._id || this.period[0]?._id || 'all';
      }
      if(this.network.length === 1) this.selectednetwork = this.network[0]._id;
      else this.selectednetwork = this.selectednetwork || "all";
      if(this.region.length === 1) this.selectedregion = this.region[0]._id;
      else this.selectedregion = this.selectedregion || "all";
      if(this.country.length === 1) this.selectedcountry = this.country[0]._id;
      else this.selectedcountry = this.selectedcountry || "all";
      // if(this.reportingunit.length === 1) this.selectedreportingunit = this.reportingunit[0]._id;
      this.selectedreportingunit = this.selectedreportingunit || "all";
      if(this.modules.length === 1) this.selectedmodule = this.modules[0]._id;
      else this.selectedmodule = this.selectedmodule || "all";
      // Ensure selectedReportingUnitType has a default if not set
      if (!this.selectedReportingUnitType || (this.selectedReportingUnitType !== 'all' && !this.reportingUnitTypeList[this.selectedReportingUnitType])) {
        // If current selection is invalid, reset to defaults
        if (this.rutypes.length === 1) this.selectedReportingUnitType = this.rutypes[0]._id;
        else this.selectedReportingUnitType = "all";
      }
      if(this.rutypes.length === 1) this.selectedrutype = this.rutypes[0]._id;
      else this.selectedrutype = this.selectedrutype || "all";
      if(this.requesttypes.length === 1) this.selectedrequesttype = this.requesttypes[0]._id;
      else this.selectedrequesttype = this.selectedrequesttype || "all";
      if(this.approvalstatuses.length === 1) this.selectedapprovalstatus = this.approvalstatuses[0]._id;
      else this.selectedapprovalstatus = this.selectedapprovalstatus || "all";

      // push all the info
      if(!stopemitflag){
        this.sendEvent("role", this.role);
        this.sendEvent("rolelist", this.rolelist);
        this.sendEvent("selectedrole", this.selectedrole);
        this.sendEvent("year", this.year);
        this.sendEvent("yearlist", this.yearlist);
        this.sendEvent("selectedyear", this.ensureValidYear());
        this.sendEvent("period", this.period);
        this.sendEvent("periodlist", this.periodlist);
        this.sendEvent("selectedperiod", this.selectedperiod);
        this.sendEvent("network", this.network);
        this.sendEvent("networklist", this.networklist);
        this.sendEvent("selectednetwork", this.selectednetwork);
        this.sendEvent("region", this.region);
        this.sendEvent("regionlist", this.regionlist);
        this.sendEvent("selectedregion", this.selectedregion);
        this.sendEvent("country", this.country);
        this.sendEvent("countrylist", this.countrylist);
        this.sendEvent("selectedcountry", this.selectedcountry);
        this.sendEvent("selectedReportingUnitType", this.selectedReportingUnitType);
        this.sendEvent("rutypes", this.rutypes);
        this.sendEvent("rutypelist", this.rutypelist);
        this.sendEvent("selectedrutype", this.selectedrutype);
        this.sendEvent("modules", this.modules);
        this.sendEvent("modulelist", this.modulelist);
        this.sendEvent("selectedmodule", this.selectedmodule);
        this.sendEvent("materialitytypes", this.materialitytypes);
        this.sendEvent("materialitylist", this.materialitylist);
        this.sendEvent("selectedmateriality", this.selectedmateriality);
        this.sendEvent("cycletypes", this.cycletypes);
        this.sendEvent("cycletypelist", this.cycletypelist);
        this.sendEvent("selectedcycletype", this.selectedcycletype);
        this.sendEvent("requesttypes", this.requesttypes);
        this.sendEvent("requesttypelist", this.requesttypelist);
        this.sendEvent("selectedrequesttype", this.selectedrequesttype);
        this.sendEvent("approvalstatuses", this.approvalstatuses);
        this.sendEvent("approvalstatuslist", this.approvalstatuslist);
        this.sendEvent("selectedapprovalstatus", this.selectedapprovalstatus);
        this.sendEvent("reportingunit", this.reportingunit);
        this.sendEvent("reportingunitlist", this.reportingunitlist);
        
        // Emit selected confirmation mode when report type is provided
        if (reportType) {
          this.sendEvent("selectedConfirmationMode", reportType);
        }
        
        this.sendEvent("selectedreportingunit", this.selectedreportingunit, forceReload);
        this.$emit('newdata', {key: 'loading', value: false});
        this.lastAppliedFilters = this.collectCurrentFilters();
        this.hasPendingApply = false;
      }
      this.setLocalFilterValues();
    },
    checkDropdown(field, key, oldlist, newlist, from=[], preselect=true){
      let data = (this.hierarchyData || {}).reportingunitlist;
      //get possible network
      let count = 0;
      let possibleids = [];

      let byruids = [];
      if(this.selectedreportingunit && this.isValidSelection(this.selectedreportingunit) && from.indexOf("ru") > -1){
        count++;
        byruids = this.getSelectableIds(field, "_id", this.selectedreportingunit, data);
      }
      let byregionids = [];
      if(this.selectedregion && this.isValidSelection(this.selectedregion) && from.indexOf("region") > -1){
        count++;
        byregionids = this.getSelectableIds(field, "region", this.selectedregion, data);
      }
      let bycountryids = [];
      if(this.selectedcountry && this.isValidSelection(this.selectedcountry) && from.indexOf("country") > -1){
        count++;
        bycountryids = this.getSelectableIds(field, "country", this.selectedcountry, data);
      }
      let bynetworkids = [];
      if(this.selectednetwork && this.isValidSelection(this.selectednetwork) && from.indexOf("network") > -1){
        count++;
        bynetworkids = this.getSelectableIds(field, "network", this.selectednetwork, data);
      }
      let newids = [...byruids, ...byregionids, ...bycountryids, ...bynetworkids];
      if(count > 0){
        let counter = {};

      for (const i of newids) {
        if (counter[i]) {
                counter[i] += 1;
            } else {
                counter[i] = 1;
            }
      }
        for (const k in counter) {
          if (Object.hasOwnProperty.call(counter, k)) {
            const el = counter[k];
            if(el === count) possibleids.push(k);            
          }
        }
        
        // Fix: If no valid intersections found but the change originated from this field explicitly,
        // preserve the selection (don't revert to 'all'). This allows selecting items with no data.
        if (possibleids.length === 0 && from.indexOf(field) > -1 && this.isValidSelection(this[key])) {
          // Handle both array and string values
          if (Array.isArray(this[key])) {
            this[key].forEach(v => possibleids.push(String(v)));
          } else {
            possibleids.push(String(this[key]));
          }
        }

        if(possibleids.length > 0) {
          if(possibleids.length === 1) {
            if(preselect) {
              const matchedId = possibleids[0];
              // Restore original type if possible - but preserve array for multi-select
              if (!Array.isArray(this[key])) {
                this[key] = this[oldlist] && this[oldlist][matchedId] ? this[oldlist][matchedId]._id : matchedId;
              }
            }
          }
          else if(!this.isSelectionInPossibleIds(this[key], possibleids)) {
            // Only reset to 'all' if the current selection doesn't intersect with possibleids
            // For arrays, check if any element is in possibleids
            if (Array.isArray(this[key])) {
              // Filter to only keep valid selections
              const validSelections = this[key].filter(v => possibleids.includes(String(v)));
              if (validSelections.length === 0) {
                this[key] = [];
              } else {
                this[key] = validSelections;
              }
            } else {
              this[key] = "all";
            }
          }
          if(possibleids.length < Object.keys(this[oldlist]).length-1){
            let first = {};
            let last = {};
            for (const k in this[oldlist]) {
              if (Object.hasOwnProperty.call(this[oldlist], k)) {
                const el = {...this[oldlist][k]};
                // Loose string check for ID inclusion
                if(possibleids.includes(String(el._id))) {
                  el.mark = "yes";
                  first[k] = el;
                }else {
                  el.mark = "no";
                  last[k] = el;
                }            
              }
            }
            this[newlist] = {...first, ...last};
          }
        }else {
          // Avoid automatic reset to 'all' to preserve "No data" state
          // Instead, just mark items as invalid in the list
          if(Object.keys(this[oldlist]) && Object.keys(this[oldlist]).length > 0) {
            let last = {};
            for (const k in this[oldlist]) {
              if (Object.hasOwnProperty.call(this[oldlist], k)) {
                const el = {...this[oldlist][k]};
                el.mark = "no";
                last[k] = el;
              }
            }
            this[newlist] = {...last};
          }
        }
      }else {
        if(from.indexOf(field) === -1) this[newlist] = this[oldlist];
      }
    },
    getSelectableIds(field, searchcolumn, value, data) {
      let uniqid = [];
      // Handle array values for multi-select
      const valueArray = Array.isArray(value) ? value.map(v => String(v)) : [String(value)];
      for (const i of data) {
        const rowValue = this.resolveHierarchyId(i[searchcolumn]);
        // Loose string comparison to handle ID type mismatches
        // Check if rowValue matches any value in the array
        if(valueArray.includes(String(rowValue))){
          const valToPush = this.resolveHierarchyId(i[field]);
          if(uniqid.indexOf(valToPush) === -1) uniqid.push(valToPush)
        }
      }
      return uniqid;
    },
    /**
     * Check if a selection (string or array) has any items in possibleids
     * @param {string|Array} selection - The current selection
     * @param {Array} possibleids - Array of possible valid IDs
     * @returns {boolean} - True if any selected item is in possibleids
     */
    isSelectionInPossibleIds(selection, possibleids) {
      if (Array.isArray(selection)) {
        return selection.some(v => possibleids.includes(String(v)));
      }
      return possibleids.includes(String(selection));
    },
    /**
     * Check if a selection value is valid (not 'all' and not empty array)
     * Handles both single string values and arrays for multi-select
     * @param {string|Array} value - The selection value to check
     * @returns {boolean} - True if the selection is valid (has actual selected items)
     */
    isValidSelection(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value && value !== 'all';
    },
    // changeRole(d) {
    //   this.selectedrole = d;
    //   this.selectedyear = "";
    //   this.selectedperiod = "";
    //   this.selectednetwork = "";
    //   this.selectedregion = "";
    //   this.selectedcountry = "";
    //   this.selectedreportingunit = "";
    //   this.setLocalFilterValues();
    //   this.refreshData();
    // },
    changeYear(d) {
      // Only set selectedyear if valid
      if (this.year.some(y => y._id === d)) {
        this.selectedyear = d;
      } else if (this.year.length > 0) {
        this.selectedyear = this.year[0]._id;
      } else {
        this.selectedyear = '';
      }
      this.recalculatePeriod();
      this.selectedperiod = this.period[1]?._id || this.period[0]?._id || 'all';
      this.selectednetwork = "all";
      this.selectedregion = "all";
      this.selectedcountry = "all";
      this.selectedreportingunit = "all";
      this.isReportSelected = true;
      this.setDropdowns(true);
      this.markFiltersPending();
    },
    changePeriod(d) {
      this.selectedperiod = d;
      // Sync selectedyear when the new period belongs to a different year
      const periodInfo = this.periodlist?.[d];
      if (periodInfo && periodInfo.year && String(periodInfo.year) !== String(this.selectedyear)) {
        this.skipPeriodRecalc = true;
        this.selectedyear = periodInfo.year;
        this.populatePeriodListOnly();
      }
      if(this.selectedreportingunit === "all"){
        this.selectednetwork = "all";
        this.selectedregion = "all";
        this.selectedcountry = "all";
        this.selectedreportingunit = "all";
        this.isReportSelected = true;
      }
      this.setDropdowns(true);
      this.markFiltersPending();
    },
    changeNetwork(d) {
      // Manual selection of network clears inference flag
      this.isHierarchyInferred = false;
      
      // Ensure value is array when multi-select is enabled
      if (this.showmultinetwork && !Array.isArray(d) && d !== 'all') {
        d = [d];
      }
      this.selectednetwork = d;
      // Only reset dependent filters if not in multi-select mode or if selection is cleared
      const isMultiSelect = this.showmultinetwork;
      const hasSelection = Array.isArray(d) ? d.length > 0 : d !== 'all';
      
      if (!isMultiSelect || !hasSelection) {
        this.selectedregion = "all";
        this.selectedcountry = "all";
        this.selectedreportingunit = "all";
        this.selectedReportingUnitType = "all";
      }
      this.regionsearch = "";
      this.countrysearch = "";
      this.searchReportingUnits = "";
      this.isReportSelected=true;
      this.setNetworkDropdown(['network']);
      this.setCountryDropdown(['network']);
      if(!this.isValidSelection(this.selectedcountry)) this.setRegionDropdown(['network']);
      else {
        this.setRegionDropdown(['network', 'country']);
      }
      this.setCountryDropdown(['network', 'region']);
      this.setReportingUnitDropdown(['network', 'region', 'country']);
      this.setDropdowns(true);
      this.markFiltersPending();
    },
    changeRegion(d) {
      // Manual selection of region clears inference flag
      this.isHierarchyInferred = false;

      // Ensure value is array when multi-select is enabled
      if (this.showmultiregion && !Array.isArray(d) && d !== 'all') {
        d = [d];
      }
      this.selectedregion = d;
      this.countrysearch = "";
      this.networksearch = "";
      this.searchReportingUnits = "";
      
      // Only reset dependent filters if not in multi-select mode or if selection is cleared
      const isMultiSelect = this.showmultiregion;
      const hasSelection = Array.isArray(d) ? d.length > 0 : d !== 'all';
      
      if (!isMultiSelect || !hasSelection) {
        this.selectedreportingunit = "all";
        this.selectedcountry = "all";
        this.selectedReportingUnitType = "all";
      }
      
      if(!this.isValidSelection(this.selectedregion)){
        if(this.isValidSelection(this.selectednetwork)){
          this.setNetworkDropdown(['network'], false);
          this.setCountryDropdown(['network'], false);
          this.setReportingUnitDropdown(['network'], false);
        }
      }else{
        if(!this.isValidSelection(this.selectednetwork)){
          this.setNetworkDropdown(['region'], false);
          this.setCountryDropdown(['region'], false);
          this.setReportingUnitDropdown(['region'], false);
        }else{
          this.setNetworkDropdown(['region']);
          this.setCountryDropdown(['region', 'network'], false);
          this.setReportingUnitDropdown(['region', 'network'], false);
        }
      }

      this.setRegionDropdown(['region']);
      this.setNetworkDropdown(['region']);
      this.setNetworkDropdown(['region', 'country']);
      this.setCountryDropdown(['region']);
      this.setCountryDropdown(['region', 'network']);
      this.setReportingUnitDropdown(['region', 'network', 'country']);
      this.setDropdowns(true);
      this.markFiltersPending();
    },
    changeCountry(d) {
      // Manual selection of country clears inference flag
      this.isHierarchyInferred = false;

      // Ensure value is array when multi-select is enabled
      if (this.showmulticountry && !Array.isArray(d) && d !== 'all') {
        d = [d];
      }
      this.selectedcountry = d;
      this.countrysearch = "";
      this.networksearch = "";
      this.searchReportingUnits = "";
      
      // Only reset dependent filters if not in multi-select mode or if selection is cleared
      const isMultiSelect = this.showmulticountry;
      const hasSelection = Array.isArray(d) ? d.length > 0 : d !== 'all';
      
      if (!isMultiSelect || !hasSelection) {
        this.selectedreportingunit = "all";
        this.selectedReportingUnitType = "all";
      }
      this.isReportSelected=true
      if(!this.isValidSelection(this.selectedcountry)){
        if(this.isValidSelection(this.selectednetwork) && this.isValidSelection(this.selectedregion)){
          this.setCountryDropdown(['network', 'region'], false);
          this.setReportingUnitDropdown(['network', 'region'], false);
          this.setNetworkDropdown(['region'], false);
          this.setRegionDropdown(['network'], false);
        }
        else if(this.isValidSelection(this.selectednetwork)){
          this.setCountryDropdown(['network'], false);
          this.setReportingUnitDropdown(['network'], false);
          this.setRegionDropdown(['network'], false);
        }
        else if(this.isValidSelection(this.selectedregion)){
          this.setCountryDropdown(['region'], false);
          this.setReportingUnitDropdown(['region'], false);
          this.setRegionDropdown(['region'], false);
        }
      }else{
        this.setRegionDropdown(['country']);
        this.setNetworkDropdown(['country', 'region']);
        this.setReportingUnitDropdown(['country'], false);
      }
      this.setDropdowns(true);
      this.markFiltersPending();
    },
    /**
     * Change the selected reporting unit.
     * When selecting from search results, add the RU to reportingunitlist if it doesn't exist.
     * @param {string} d - The reporting unit ID to select
     */
    changeReportingUnit(d) {
      // Capture detailed filter state before any changes
      // If filters were already inferred from a previous RU selection, treat them as 'all' (not manual)
      const wasAlreadyInferred = this.isHierarchyInferred;
      const initialNetwork = this.selectednetwork;
      const initialRegion = this.selectedregion;
      const initialCountry = this.selectedcountry;

      this.selectedreportingunit = d;
      // Mark as inferred since we are about to auto-populate hierarchy filters
      // This will be refined at the end of the function based on wasAll check
      this.isHierarchyInferred = (d && d !== 'all');
      
      this.countrysearch = "";
      this.networksearch = "";
      this.searchReportingUnits = "";
      
      // Auto-populate cascading filters when RU is selected
      let effectiveId = null;
      if (Array.isArray(d)) {
         if (d.length === 1) effectiveId = d[0];
      } else {
         effectiveId = d;
      }

      if (effectiveId && effectiveId !== "all") {
        let selectedRU = null;
        
        // PRIORITY 1: Look up RU in hierarchyData.reportingunitlist (the source of truth from API)
        const hierarchyRUList = (this.hierarchyData || {}).reportingunitlist || [];
        const hierarchyRU = hierarchyRUList.find(ru => ru._id === effectiveId);
        if (hierarchyRU) {
          if (hierarchyRU.network) this.selectednetwork = hierarchyRU.network._id || hierarchyRU.network;
          if (hierarchyRU.region) this.selectedregion = hierarchyRU.region._id || hierarchyRU.region;
          if (hierarchyRU.country) this.selectedcountry = hierarchyRU.country._id || hierarchyRU.country;
          const ruType = hierarchyRU.type || hierarchyRU.rutype || hierarchyRU.ru_type;
          
          if (ruType) {
            const lower = String(ruType).toLowerCase();
            if (this.reportingUnitTypeList[ruType]) {
              this.selectedReportingUnitType = ruType;
            } else if (this.reportingUnitTypeList[lower]) {
              this.selectedReportingUnitType = lower;
            } else {
              this.$set(this.reportingUnitTypeList, lower, { _id: lower, name: ruType.toUpperCase() });
              this.selectedReportingUnitType = lower;
            }
          }
        }
        
        // PRIORITY 2: Check pendingExternalReportingUnit (from list click)
        if (this.pendingExternalReportingUnit && this.pendingExternalReportingUnit.id === effectiveId) {
          const context = this.pendingExternalReportingUnit.context || {};
          // Only override if we have actual values (not null/undefined/empty)
          if (context.network && this.selectednetwork === 'all') this.selectednetwork = context.network._id || context.network;
          if (context.region && this.selectedregion === 'all') this.selectedregion = context.region._id || context.region;
          if (context.country && this.selectedcountry === 'all') this.selectedcountry = context.country._id || context.country;
          if (context.type && this.selectedReportingUnitType === 'all') this.selectedReportingUnitType = context.type;
        } else if (this.reportingunitlist[effectiveId] && this.reportingunitlist[effectiveId].context) {
             // Fallback: Check if the RU in the list has a context object attached
             const context = this.reportingunitlist[effectiveId].context;
             if (context.network && this.selectednetwork === 'all') this.selectednetwork = context.network;
             if (context.region && this.selectedregion === 'all') this.selectedregion = context.region;
             if (context.country && this.selectedcountry === 'all') this.selectedcountry = context.country;
             if (context.type && this.selectedReportingUnitType === 'all') this.selectedReportingUnitType = context.type;
        }
        
        // PRIORITY 3: Check if RU exists in reportingunitlist (filtered/processed list)
        if (this.reportingunitlist[effectiveId]) {
          selectedRU = this.reportingunitlist[effectiveId];
          if (selectedRU.network) this.selectednetwork = selectedRU.network._id || selectedRU.network;
          if (selectedRU.region) this.selectedregion = selectedRU.region._id || selectedRU.region;
          if (selectedRU.country) this.selectedcountry = selectedRU.country._id || selectedRU.country;

          // Handle Type selection (case-insensitive match)
          const rawType = selectedRU.type || selectedRU.rutype || (selectedRU.context ? selectedRU.context.type : null);
          if (rawType) {
            const lower = String(rawType).toLowerCase();
            const upper = String(rawType).toUpperCase();
            
            if (this.reportingUnitTypeList[rawType]) {
              this.selectedReportingUnitType = rawType;
            } else if (this.reportingUnitTypeList[lower]) {
              this.selectedReportingUnitType = lower;
            } else if (this.reportingUnitTypeList[upper]) {
              this.selectedReportingUnitType = upper;
            } else {
               this.$set(this.reportingUnitTypeList, lower, {
                  _id: lower,
                  name: upper === 'JV' ? 'JV' : upper === 'RU' ? 'RU' : upper
               });
               this.selectedReportingUnitType = lower;
            }
          }
        } 
        // If RU selected from search is not in original list, add it
        else {
          let searchedRU = null;
          if (Array.isArray(this.newreportingunitlist)) {
            searchedRU = this.newreportingunitlist.find(ru => ru._id === effectiveId);
          } else if (this.newreportingunitlist && this.newreportingunitlist[effectiveId]) {
            searchedRU = this.newreportingunitlist[effectiveId];
          }
          if (searchedRU) {
            this.$set(this.reportingunitlist, effectiveId, searchedRU);
            
            if (searchedRU.network) this.selectednetwork = searchedRU.network._id || searchedRU.network;
            if (searchedRU.region) this.selectedregion = searchedRU.region._id || searchedRU.region;
            if (searchedRU.country) this.selectedcountry = searchedRU.country._id || searchedRU.country;
            
            const rawType = searchedRU.type || searchedRU.rutype || (searchedRU.context ? searchedRU.context.type : null);
            if (rawType) {
                const lower = String(rawType).toLowerCase();
                const upper = String(rawType).toUpperCase();

                if (this.reportingUnitTypeList[rawType]) {
                  this.selectedReportingUnitType = rawType;
                } else if (this.reportingUnitTypeList[lower]) {
                  this.selectedReportingUnitType = lower;
                } else if (this.reportingUnitTypeList[upper]) {
                    this.selectedReportingUnitType = upper;
                } else {
                   this.$set(this.reportingUnitTypeList, lower, {
                      _id: lower,
                      name: upper === 'JV' ? 'JV' : upper === 'RU' ? 'RU' : upper
                   });
                   this.selectedReportingUnitType = lower;
                }
            }
          }
        }
        
        // PRIORITY 4: Infer missing higher-level hierarchy (Region/Country) using Sibling Lookup and Parent Metadata
        if (this.hierarchyData) {
            let inferredCountry = null;
            let inferredRegion = null;
            
            // 1. Try to infer from Network Metadata (if available)
            if (this.selectednetwork && this.selectednetwork !== 'all' && this.networklist) {
                const networkObj = this.networklist[this.selectednetwork];
                if (networkObj) {
                    inferredCountry = this.resolveHierarchyId(networkObj.country);
                    inferredRegion = this.resolveHierarchyId(networkObj.region);
                }
            }
            
            // 2. Try to infer from Sibling RUs (if Network metadata didn't have it)
            if ((!inferredCountry || !inferredRegion) && this.selectednetwork && this.selectednetwork !== 'all') {
                 // Check if any other RU in the same network has country/region info
                 const allRUs = this.hierarchyData.reportingunitlist || [];
                 const sibling = allRUs.find(r => {
                     const rNet = this.resolveHierarchyId(r.network);
                     return rNet === this.selectednetwork && (this.resolveHierarchyId(r.country) || this.resolveHierarchyId(r.region)) && r._id !== d;
                 });
                 
                 if (sibling) {
                     if (!inferredCountry) inferredCountry = this.resolveHierarchyId(sibling.country);
                     if (!inferredRegion) inferredRegion = this.resolveHierarchyId(sibling.region);
                 }
            }
            
            // 3. Try to infer Region from Country (if Country is known but Region isn't)
            if (!inferredRegion && (this.selectedcountry !== 'all' || inferredCountry)) {
                const cId = (this.selectedcountry !== 'all') ? this.selectedcountry : inferredCountry;
                if (cId && this.countrylist && this.countrylist[cId]) {
                    inferredRegion = this.resolveHierarchyId(this.countrylist[cId].region);
                }
            }

            // Apply Inferences
            if (inferredCountry && (!this.selectedcountry || this.selectedcountry === 'all')) {
                this.selectedcountry = inferredCountry;
                // Patch the current RU in hierarchyData to ensure validation passes
                const ruToPatch = (this.hierarchyData.reportingunitlist || []).find(r => r._id === d);
                if (ruToPatch && !ruToPatch.country) ruToPatch.country = inferredCountry;
                if (this.reportingunitlist[d] && !this.reportingunitlist[d].country) this.reportingunitlist[d].country = inferredCountry;
            }
            
            if (inferredRegion && (!this.selectedregion || this.selectedregion === 'all')) {
                this.selectedregion = inferredRegion;
                // Patch the current RU in hierarchyData
                const ruToPatch = (this.hierarchyData.reportingunitlist || []).find(r => r._id === d);
                if (ruToPatch && !ruToPatch.region) ruToPatch.region = inferredRegion;
                if (this.reportingunitlist[d] && !this.reportingunitlist[d].region) this.reportingunitlist[d].region = inferredRegion;
            }
        }
      }
      
      // Reset fetched reporting units to original/full list
      this.newreportingunitlist = { ...this.reportingunitlist };
      
      // Preserve the newly set values before validation logic might reset them
        

      
      // Preserve the newly set values before validation logic might reset them
      const currentRUType = this.selectedReportingUnitType;
      const currentNetwork = this.selectednetwork;
      const currentRegion = this.selectedregion;
      const currentCountry = this.selectedcountry;


      if (this.selectedreportingunit === "all") {
        this.setCountryDropdown(['region', 'network']);
      } else {
        this.regionsearch = "";
        this.countrysearch = "";
        this.networksearch = "";
        // Ensure the selected RU is in hierarchyData.reportingunitlist for filtering
        if (this.hierarchyData && this.hierarchyData.reportingunitlist) {
             const exists = this.hierarchyData.reportingunitlist.some(r => r._id === d);
             if (!exists && this.reportingunitlist[d]) {
                 // Add to hierarchyData so checkDropdown works correctly
                 this.hierarchyData.reportingunitlist.push(this.reportingunitlist[d]);
             }
        }

        this.setCountryDropdown(['ru']);
        this.setRegionDropdown(['ru']);
        this.setNetworkDropdown(['ru']);
      }
      this.pendingExternalReportingUnit = null;
      this.setDropdowns(true);
      

      // Explicitly restore values if they were set during changeReportingUnit but reset by validation
      // This ensures that even if hierarchy data is incomplete, the user manually selected values are preserved
      if (currentRUType && currentRUType !== 'all' && this.selectedReportingUnitType !== currentRUType) {
         this.selectedReportingUnitType = currentRUType;
         this.sendEvent("selectedReportingUnitType", this.selectedReportingUnitType); 
      }
      if (currentNetwork && currentNetwork !== 'all' && this.selectednetwork === 'all') {
         this.selectednetwork = currentNetwork;
      }
      if (currentRegion && currentRegion !== 'all' && this.selectedregion === 'all') {
         this.selectedregion = currentRegion;
      }
      if (currentCountry && currentCountry !== 'all' && this.selectedcountry === 'all') {
         this.selectedcountry = currentCountry;
      }

      // Mark that this change was part of an RU hierarchy inference
      // This flag tells helpers.js to reset these filters when returning to list view
      // UNLESS the values were already manually set (i.e. we are just confirming an existing selection)
      // We use the INITIAL state (captured at start of function) to determine if filters were 'all' before this change.
      
      const wasAll = ((!initialNetwork || initialNetwork === 'all') && 
                     (!initialRegion || initialRegion === 'all') && 
                     (!initialCountry || initialCountry === 'all')) || wasAlreadyInferred;

      if (wasAll) {
         this.isHierarchyInferred = true;
         this.$emit('hierarchy-inferred', true);
      } else {
         this.isHierarchyInferred = false;
         this.$emit('hierarchy-inferred', false);
      }
      
      this.markFiltersPending();
    },
    setNetworkDropdown(from=[], preselect=true) {
      this.checkDropdown('network', 'selectednetwork', 'networklist', 'newnetworklist', from, preselect);
    },
    setRegionDropdown(from=[], preselect=true) {
      this.checkDropdown('region', 'selectedregion', 'regionlist', 'newregionlist', from, preselect);
    },
    setCountryDropdown(from=[], preselect=true) {
      this.checkDropdown('country', 'selectedcountry', 'countrylist', 'newcountrylist', from, preselect);
    },
    setReportingUnitDropdown(from=[], preselect=true) {
      this.checkDropdown('_id', 'selectedreportingunit', 'reportingunitlist', 'newreportingunitlist', from, preselect);
    },
    sortData(data){
      return data.sort((a, b) => a.name.localeCompare(b.name));
    },
    recalculatePeriod(){
      let tperiodlist = {};
      let fullperiodlist = {};
      // If selectedyear is 'all' or not set, show all periods
      const showAllYears = !this.selectedyear || this.selectedyear === 'all';
      
      for (const i of this.allperiod) {
        // Format period name with month and year for clarity
        const periodDisplayName = `${i.month} - ${i.year}`;
        // Always add to full list
        fullperiodlist[i._id] = {name: periodDisplayName, _id: i._id, number: i.number, year: i.year};

        // Use string comparison to handle both number and string year values
        if(showAllYears || String(i.year) === String(this.selectedyear)) {
          tperiodlist[i._id] = {name: periodDisplayName, _id: i._id, number: i.number, year: i.year};
        }
      }
      let tperiod = [];
      let hasselected = false;
      tperiodlist = this.sortObjectsByNumberDescending(tperiodlist, 'number');
      for (const k in tperiodlist) {
        if (Object.hasOwnProperty.call(tperiodlist, k)) {
          const el = tperiodlist[k];
          if(el._id === this.selectedperiod) hasselected = true;
          tperiod.push({_id: el._id, name: el.name, number: el.number, year: el.year});
        }
      }
      // periodlist should contain ALL periods for lookup/parent usage
      this.periodlist = fullperiodlist;
      // period dropdown contains only filtered periods
      this.period = tperiod;
      if(!hasselected) this.selectedperiod = this.period[1]?._id || this.period[0]?._id || '';
    },
    
    // Populate period list without changing selectedperiod - used when restoring filters on back navigation
    populatePeriodListOnly(){
      let tperiodlist = {};
      let fullperiodlist = {};
      const showAllYears = !this.selectedyear || this.selectedyear === 'all';

      for (const i of this.allperiod) {
        // Format period name with month and year for clarity
        const periodDisplayName = `${i.month} - ${i.year}`;
        // Always add to full list
        fullperiodlist[i._id] = {name: periodDisplayName, _id: i._id, number: i.number, year: i.year};

        if(showAllYears || String(i.year) === String(this.selectedyear)) {
          tperiodlist[i._id] = {name: periodDisplayName, _id: i._id, number: i.number, year: i.year};
        }
      }
      
      let tperiod = [];
      tperiodlist = this.sortObjectsByNumberDescending(tperiodlist, 'number');
      for (const k in tperiodlist) {
        if (Object.hasOwnProperty.call(tperiodlist, k)) {
          const el = tperiodlist[k];
          tperiod.push({_id: el._id, name: el.name, number: el.number, year: el.year});
        }
      }
      
      // periodlist should contain ALL periods for lookup/parent usage
      this.periodlist = fullperiodlist;
      // period dropdown contains only filtered periods
      this.period = tperiod;
      // Don't change selectedperiod - keep the restored value
    },
    sortObjectsByNumberDescending(obj,sortKey = 'number'){
      const entries = Object.entries(obj);
      const entriesWithNumber = entries.filter(([, value]) => Object.prototype.hasOwnProperty.call(value, sortKey));
      entriesWithNumber.sort((a, b) => b[1].number - a[1].number);
      const sortedObj = {};
      for (const [key, value] of entriesWithNumber) {
        sortedObj[key] = value;
      }
      for (const [key, value] of entries) {
        if (!Object.prototype.hasOwnProperty.call(value, sortKey)) {
          sortedObj[key] = value;
        }
      }
      return sortedObj;
    },
    setReportingUnitDropdownByType(typeId) {
      // Filter reporting units based on the selected RU Type
      let data = (this.hierarchyData || {}).reportingunitlist || [];
      let filteredRUs = {};
      
      for (const ru of data) {
        // Match based on type field or other criteria
        if (typeId === 'soxid' && ru.is_sox) {
          filteredRUs[ru._id] = {
            _id: ru._id,
            name: ru.code + " - " + ru.name,
            cycle: ru.cycle
          };
        } else if (typeId === 'jv' && ru.type === 'jv') {
          filteredRUs[ru._id] = {
            _id: ru._id,
            name: ru.code + " - " + ru.name,
            cycle: ru.cycle
          };
        }
      }
      
      // Add 'All' option if there are filtered results
      if (Object.keys(filteredRUs).length > 0) {
        filteredRUs = { all: { ...this.alldata }, ...filteredRUs };
      }
      
      this.newreportingunitlist = filteredRUs;
    },
    setFilterItem(filterData){
      const fallbackSecondPeriod = (this.period[2] || {})._id;
      const fallbackFirstPeriod = (this.period[0] || {})._id;
      this.selectedperiod = filterData.selectedperiod || fallbackSecondPeriod || fallbackFirstPeriod || "all";
      this.selectedreportingunit = filterData.selectedreportingunit || "all";
      this.selectedcountry = filterData.selectedcountry || "all";
      this.selectedregion = filterData.selectedregion || "all";
      this.selectednetwork = filterData.selectednetwork || "all";
      this.selectedyear = this.ensureValidYear(filterData.selectedyear);
      // Restore isHierarchyInferred flag if available in filterData
      // If not present, default to false (assume it's clean state or manual)
      this.isHierarchyInferred = filterData.isHierarchyInferred === true;

      // Restore selectedReportingUnitType - default to 'all' when going back
      this.selectedReportingUnitType = filterData.selectedReportingUnitType || "all";
      if(filterData.emit){
        this.sendEvent("selectedyear", this.selectedyear);
        this.sendEvent("selectedperiod", this.selectedperiod);
        this.sendEvent("selectednetwork", this.selectednetwork);
        this.sendEvent("selectedregion", this.selectedregion);
        this.sendEvent("selectedcountry", this.selectedcountry);
        this.sendEvent("reportingunit", this.reportingunit);
        this.sendEvent("reportingunitlist", this.reportingunitlist);
        this.sendEvent("selectedReportingUnitType", this.selectedReportingUnitType);
        this.sendEvent("selectedreportingunit", this.selectedreportingunit, true);
      }
    },
    setPreviousFilterState(filterState){
      if (this.cycletype === "Actual") this.$store.commit(this.appname + "/setPreviousActualFilterState", filterState);
      else if (this.cycletype === "Forecast") this.$store.commit(this.appname + "/setPreviousForecastFilters", filterState);
        this.previousFilterState =  filterState;
    },
  },
  computed: {
    /**
     * Combined loading state for Apply button
     * Returns true if either local apply loading or parent API loading is in progress
     * This ensures the button stays disabled until getreportingunitpagination/getreportinunitdata completes
     */
    isApplyButtonLoading() {
      return this.isApplyLoading || this.isLoading;
    },
    /**
     * Check if multiple reporting units are selected (for confirmation popup)
     * Returns true when multi-select is enabled AND more than one RU is selected
     */
    hasMultipleReportingUnitsSelected() {
      // Only applies when multi-select is enabled
      if (!this.showmultireportingunit) {
        return false;
      }
      
      // No selection or invalid value (undefined, null, empty string) - not multiple
      if (!this.selectedreportingunit || this.selectedreportingunit === '') {
        return false;
      }
      
      // "All" with multi-select means all RUs = multiple
      if (this.selectedreportingunit === 'all') {
        return true;
      }
      
      // Empty array - no selection
      if (Array.isArray(this.selectedreportingunit) && this.selectedreportingunit.length === 0) {
        return false;
      }
      
      // Array with more than 1 item
      if (Array.isArray(this.selectedreportingunit)) {
        return this.selectedreportingunit.length > 1;
      }
      
      // Comma-separated string check
      if (typeof this.selectedreportingunit === 'string' && 
          this.selectedreportingunit.includes(',')) {
        return this.selectedreportingunit.split(',').filter(Boolean).length > 1;
      }
      
      // Single valid RU selection - not multiple
      return false;
    },
    favouriteContext() {
      return {
        selectedyear: this.ensureValidYear(),
        selectedperiod: this.selectedperiod,
        selectednetwork: this.selectednetwork,
        selectedregion: this.selectedregion,
        selectedcountry: this.selectedcountry,
        selectedreportingunit: this.selectedreportingunit,
        selectedReportingUnitType: this.selectedReportingUnitType,
        cycletype: this.cycletype,
      };
    },
    favouriteLookupMaps() {
      return {
        periodlist: this.periodlist,
        networklist: this.networklist,
        regionlist: this.regionlist,
        countrylist: this.countrylist,
        reportingunitlist: this.reportingunitlist,
        reportingUnitTypeList: this.reportingUnitTypeList,
      };
    },
    /**
     * Returns the items for the Type filter.
     */
    typeFilterItems() {
      // Logic for loading state is handled by FilterTypes component via :loading prop
      return this.reportingUnitTypeList;
    },
    /**
     * Shows loader only during getaccesshierarchyV2 API call.
     * Other APIs (getreportingunit_pagination, getreportingunit) should NOT affect this.
     */
    showLoader() {
      return this.loading;
    },
    /**
     * Returns true if filter data is loading (for sync icon animation)
     */
    isFiltersDataLoading() {
      // Use the most relevant loading flags for filter data
      return this.loading || this.reportingunitapiloading;
    },
    topnetworklist(){
      let rdt = [];
      for (const k in this.newnetworklist) {
        if (Object.hasOwnProperty.call(this.newnetworklist, k)) {
          const el = this.newnetworklist[k];
          if(el.name.replaceAll(' ', '').toLowerCase().indexOf((this.networksearch || '').replaceAll(' ', '').toLowerCase()) >-1 && el._id !== "all") rdt.push(el);
        }
      }
      rdt = rdt.sort((a,b) => a.name > b.name);
      rdt = rdt.sort((a,b) => (a.mark === 'yes' && b.mark === 'no') ? -1 : 0);
      return rdt;
    },
    topregionlist(){
      let rdt = [];
      for (const k in this.newregionlist) {
        if (Object.hasOwnProperty.call(this.newregionlist, k)) {
          const el = this.newregionlist[k];
          if(el.name.replaceAll(' ', '').toLowerCase().indexOf((this.regionsearch || '').replaceAll(' ', '').toLowerCase()) >-1 && el._id !== "all") rdt.push(el);
        }
      }
      rdt = rdt.sort((a,b) => a.name > b.name);
      rdt = rdt.sort((a,b) => (a.mark === 'yes' && b.mark === 'no') ? -1 : 0);
      return rdt;
    },
    topcountrylist(){
      let rdt = [];
      for (const k in this.newcountrylist) {
        if (Object.hasOwnProperty.call(this.newcountrylist, k)) {
          const el = this.newcountrylist[k];
          if(el.name.replaceAll(' ', '').toLowerCase().indexOf((this.countrysearch || '').replaceAll(' ', '').toLowerCase()) >-1 && el._id !== "all") rdt.push(el);
        }
      }
      rdt = rdt.sort((a,b) => a.name > b.name);
      rdt = rdt.sort((a,b) => (a.mark === 'yes' && b.mark === 'no') ? -1 : 0);
      return rdt;
    },
    topReportingUnitList() {
      let search = (this.debouncedRUsearch || '').replace(/\s+/g, '').toLowerCase();
      let rdt = [];
      for (const k in this.newreportingunitlist) {
        if (Object.hasOwnProperty.call(this.newreportingunitlist, k)) {
          const el = this.newreportingunitlist[k];
          // Skip the "all" item - it's rendered separately by FilterTypes
          if (el._id === 'all') continue;
          const name = (el.name || '').replace(/\s+/g, '').toLowerCase();
          if (!search || search.length < 3) {
            rdt.push(el);
          } else if (name.includes(search)) {
            rdt.push(el);
          }
        }
      }
      rdt.sort((a, b) => {
        if (a.mark === 'yes' && b.mark !== 'yes') return -1;
        if (b.mark === 'yes' && a.mark !== 'yes') return 1;
        return a.name.localeCompare(b.name);
      });

      return rdt;
    }
  },

}
</script>

<style scoped>
  /* Fixed width for filters */
  ::v-deep .filter-year, 
  ::v-deep .filter-period {
    width: 170px !important;
    max-width: 170px !important;
  }

  ::v-deep .filter-type {
    width: 100px !important;
    max-width: 100px !important;
  }
  
  ::v-deep .filter-network, 
  ::v-deep .filter-region, 
  ::v-deep .filter-country {
    width: 120px !important;
    max-width: 120px !important;
  }

  ::v-deep .filter-reportingunit {
    width: 160px !important;
    max-width: 160px !important;
  }

    ::v-deep .filter-module {
    width: 150px !important;
    max-width: 150px !important;
  }

    ::v-deep .filter-role {
    width: 180px !important;
    max-width: 180px !important;
  }

    ::v-deep .filter-materiality {
    width: 150px !important;
    max-width: 150px !important;
  }
    ::v-deep .filter-cycletype {
    width: 120px !important;
    max-width: 120px !important;
  }
    ::v-deep .filter-requesttype {
    width: 200px !important;
    max-width: 200px !important;
  }

  .reportingunit-list{
    min-width: 300px;
    max-height: 300px;
  }
  .scrollbar-list{
    min-height: 300px;
    min-width: 300px;
  }

  /* Restore container styling */
  .cycle-filter-bg {
    background-color: #ffffff !important;
    border: 1px solid #E5E5E5 !important;
    border-radius: 8px !important;
    padding: var(--space-5);
    box-shadow: 0px 4px 4px 0px #00000014 !important;
  }

  /* Removed obsolete favourites modal styles */


  .hoverable{
    padding: var(--padding-2xs) var(--padding-xs) !important;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: var(--radius-8);
  }
  .hoverable:hover {
    background-color: var(--cycle-filter-section-bg) !important;
    border-radius: var(--radius-8);
  }
  :deep(.hoverable):hover .arrow-icon {
    transform: rotate(180deg);
  }

  /* Text styling */
  .hoverable .grey--text {
    color: #64748b !important;
    font-weight: 500;
    /* margin-bottom: 8px; */
    text-transform: none !important;
    letter-spacing: normal !important;
    font-size: var(--font-size-xxs);
  }

  .hoverable .font-weight-bold {
    color: #0f172a !important; /* Slate-900 for values */
    font-weight: 600 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  /* Filter value container - FIXED with truncation */
  ::v-deep .filter-hide {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #0f172a !important;
    padding: 0;
    border-radius: 0;
    min-height: 20px;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }

  ::v-deep .filter-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    flex: 1;
    text-align: left;
  }

  .filter-hide:hover {
    background-color: transparent !important;
  }

  .filter-hide .v-icon {
    color: #94a3b8 !important; /* Lighter chevron */
    font-size: 16px;
    flex-shrink: 0; /* Prevent icon from shrinking */
  }

  /* Custom Divider */
/* Need to point the background color from colors.scss */
  .filter-divider {
    display: block;
    height: 36px;
    width: 1px;
    background-color: #cbcbcc;
  }

  /* Button Styling */



  .apply-btn {
    border-radius: 6px;
    font-weight: 500;
    letter-spacing: normal;
    text-transform: none !important;
  }

  .favourites-btn {
    color: #334155 !important;
    border-radius: 6px;
    font-weight: 500;
    letter-spacing: normal;
    text-transform: none !important;
  }

  /* Reset button styling */
   .v-btn--icon {
    background-color: transparent !important;
    color: #64748b !important;
    border-radius: 50%;
  }

   .v-btn--icon:hover {
    background-color: #f1f5f9 !important;
    /* color: #ef4444 !important; */
  }

   .v-btn--icon .v-icon {
    color: inherit !important;
  }

  /* Dropdown menu styling */
   .v-menu__content {
    border-radius: 12px !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
    border: 1px solid #e2e8f0;
    margin-top: 8px;
    z-index: 9999 !important;
  }

   .v-list {
    padding: 4px;
  }

   .v-list-item {
    margin-bottom: 2px;
  }

   .v-list-item:hover {
    background-color: var(--cycle-filter-section-bg) !important;
  }

  /* Dropdown list item title styling */
  .v-list-item-title {
    font-size: var(--font-size-xs) !important;
    font-weight: 500 !important;
    color: #0f172a !important;
  }

  /* Keep the "X more" text smaller */
  .v-list-item-title.caption {
    font-size: var(--font-size-xxs) !important;
    font-weight: 400 !important;
  }

  /* Helper classes */
  .text-center {
    text-align: left !important; /* Align text to left like Figma */
  }

  .noTransform {
    text-transform: none !important;
   
  }

  /* Gemini AI Style Loader - Traversing Border Animation */
  .gemini-loader-container {
    position: relative;
    border-radius: 10px;
    padding: 2px;
    background: transparent;
    transition: box-shadow 0.3s ease;
  }

  .gemini-loader-container.loading {
    animation: gemini-shadow-pulse 2s ease-in-out infinite;
  }

  .gemini-loader-container.loading::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 2px;
    background: linear-gradient(90deg, 
      var(--color-primary-alt), 
      var(--logo-color), 
      var(--logo-color1), 
      var(--logo-color2), 
      var(--logo-color3));
    background-size: 400% 100%;
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    animation: gemini-border-flow 3s linear infinite;
    pointer-events: none;
  }

  @keyframes gemini-border-flow {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 400% 50%;
    }
  }

  @keyframes gemini-shadow-pulse {
    0%, 100% {
      box-shadow: 0 0 10px #667085A6, 0 0 20px #66708526;
    }
    50% {
      box-shadow: 0 0 25px #667085CC, 0 0 50px #6670854D;
    }
  }

  .v-menu__content {
    z-index: 9999 !important;
  }

  /* Report Generation Confirmation Menu Styles */
  .report-generation-menu__card {
    border-radius: var(--radius-8) !important;
    overflow: hidden;
  }

  .report-generation-menu__header {
    background-color: var(--color-surface-default);
  }

  ::v-deep(.module-radio-group) .v-input--radio-group__input {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-3, 12px);
  } 

  .radio-card-wrapper {
    display: flex;
    height: var(--size-nav-item-height, 44px);
    padding: 0 var(--padding-sm, 12px);
    align-items: center;
    align-content: center;
    gap: var(--space-xs, 8px);
    align-self: stretch;
    flex-wrap: wrap;
    border-radius: var(--radius-8, 8px);
    justify-content: space-between;
    border: 1px solid var(--Primary-Colour, #193541);
    background: var(--background-gray-weak, #FFF);
    cursor: pointer;
    transition: all var(--duration-fast, 150ms) var(--ease-standard, ease);
    color: var(--grey-500);
  }

  .radio-card-wrapper:hover {
    border-color: var(--color-primary);
    background-color: var(--color-hover-bg);
  }

  .radio-card-wrapper--selected {
    border-color: var(--color-primary);
    background-color: var(--primary-50);
  }

  .module-radio {
    margin: 0 !important;
    padding: 0 !important;
    flex-shrink: 0;
  }

  .module-radio ::v-deep .v-input--selection-controls__input {
    margin: 0;
  }

  .radio-text {
    font-size: var(--font-size-sm);
    font-weight: 500;
    color: var(--grey-500);
  }

  .radio-card-wrapper--selected .radio-text {
    color: var(--color-primary);
  }

  .information-chip {
    width: 100%;
    height: auto !important;
    white-space: normal;
  }

  .information-chip span {
    white-space: normal;
    line-height: 1.4;
  }

  /* Apply button pending state */
  .apply-btn--pending {
    animation: pulse-border 1.5s ease-in-out infinite;
  }

  @keyframes pulse-border {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(var(--blue-500-rgb), 0.4);
    }
    50% {
      box-shadow: 0 0 0 4px rgba(var(--blue-500-rgb), 0);
    }
  }
</style>